var _defs, _line, _line2, _line3, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path0, _g0, _path1, _g1, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _path22, _g22, _path23, _g23, _path24, _g24, _path25, _g25, _path26, _g26, _path27, _g27, _path28, _g28, _path29, _g29, _path30, _g30, _path31, _g31, _path32, _g32, _path33, _g33, _path34, _g34, _path35, _g35, _path36, _g36, _path37, _g37, _path38, _g38, _path39, _g39, _path40, _g40, _path41, _g41, _path42, _g42, _path43, _g43, _path44, _g44, _path45, _g45, _path46, _g46, _path47, _g47, _path48, _g48, _path49, _g49, _path50, _g50, _path51, _g51, _path52, _g52, _path53, _line4, _g53, _g54, _line5, _g55, _g56, _line6, _g57, _g58, _path54, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestmentInRdByEuMemberStatesGdpDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 382.68 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        clip-path: url(#clippath-51);\n      }\n\n      .st1 {\n        clip-path: url(#clippath-34);\n      }\n\n      .st2 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st3 {\n        clip-path: url(#clippath-38);\n      }\n\n      .st4 {\n        clip-path: url(#clippath-21);\n      }\n\n      .st5 {\n        clip-path: url(#clippath-6);\n      }\n\n      .st6 {\n        clip-path: url(#clippath-7);\n      }\n\n      .st7 {\n        clip-path: url(#clippath-17);\n      }\n\n      .st8 {\n        clip-path: url(#clippath-31);\n      }\n\n      .st9 {\n        clip-path: url(#clippath-15);\n      }\n\n      .st10 {\n        clip-path: url(#clippath-33);\n      }\n\n      .st11 {\n        clip-path: url(#clippath-18);\n      }\n\n      .st12 {\n        clip-path: url(#clippath-47);\n      }\n\n      .st13 {\n        clip-path: url(#clippath-4);\n      }\n\n      .st14 {\n        fill: url(#linear-gradient10);\n      }\n\n      .st15 {\n        clip-path: url(#clippath-22);\n      }\n\n      .st16 {\n        clip-path: url(#clippath-23);\n      }\n\n      .st17 {\n        fill: url(#linear-gradient21);\n      }\n\n      .st18 {\n        clip-path: url(#clippath-9);\n      }\n\n      .st19 {\n        clip-path: url(#clippath-10);\n      }\n\n      .st20 {\n        clip-path: url(#clippath-42);\n      }\n\n      .st21 {\n        clip-path: url(#clippath-43);\n      }\n\n      .st22 {\n        fill: url(#linear-gradient26);\n      }\n\n      .st23 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st24 {\n        clip-path: url(#clippath-25);\n      }\n\n      .st25 {\n        clip-path: url(#clippath-27);\n      }\n\n      .st26 {\n        fill: url(#linear-gradient9);\n      }\n\n      .st27 {\n        fill: #f1f1f2;\n      }\n\n      .st28 {\n        fill: url(#linear-gradient18);\n      }\n\n      .st29 {\n        fill: url(#linear-gradient23);\n      }\n\n      .st30 {\n        clip-path: url(#clippath-11);\n      }\n\n      .st31 {\n        fill: url(#linear-gradient8);\n      }\n\n      .st32 {\n        fill: url(#linear-gradient11);\n      }\n\n      .st33, .st34, .st35 {\n        fill: none;\n      }\n\n      .st36 {\n        clip-path: url(#clippath-36);\n      }\n\n      .st37 {\n        clip-path: url(#clippath-35);\n      }\n\n      .st38 {\n        clip-path: url(#clippath-48);\n      }\n\n      .st39 {\n        clip-path: url(#clippath-28);\n      }\n\n      .st40 {\n        fill: url(#linear-gradient16);\n      }\n\n      .st41 {\n        fill: url(#linear-gradient24);\n      }\n\n      .st42 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st43 {\n        fill: url(#linear-gradient22);\n      }\n\n      .st44 {\n        clip-path: url(#clippath-45);\n      }\n\n      .st45 {\n        isolation: isolate;\n      }\n\n      .st46 {\n        clip-path: url(#clippath-46);\n      }\n\n      .st47 {\n        clip-path: url(#clippath-40);\n      }\n\n      .st48 {\n        clip-path: url(#clippath-5);\n      }\n\n      .st49 {\n        clip-path: url(#clippath-20);\n      }\n\n      .st50 {\n        clip-path: url(#clippath-8);\n      }\n\n      .st51 {\n        fill: url(#linear-gradient19);\n      }\n\n      .st52 {\n        fill: url(#linear-gradient12);\n      }\n\n      .st53 {\n        clip-path: url(#clippath-52);\n      }\n\n      .st54 {\n        clip-path: url(#clippath-41);\n      }\n\n      .st55 {\n        clip-path: url(#clippath-3);\n      }\n\n      .st56 {\n        clip-path: url(#clippath-26);\n      }\n\n      .st57 {\n        fill: url(#linear-gradient7);\n      }\n\n      .st58 {\n        clip-path: url(#clippath-12);\n      }\n\n      .st59 {\n        clip-path: url(#clippath-50);\n      }\n\n      .st60 {\n        fill: url(#linear-gradient20);\n      }\n\n      .st61 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st62 {\n        clip-path: url(#clippath-14);\n      }\n\n      .st63 {\n        clip-path: url(#clippath-30);\n      }\n\n      .st64 {\n        clip-path: url(#clippath-19);\n      }\n\n      .st65 {\n        fill: url(#linear-gradient14);\n      }\n\n      .st66 {\n        fill: url(#linear-gradient5);\n      }\n\n      .st67 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st68 {\n        clip-path: url(#clippath-32);\n      }\n\n      .st69 {\n        fill: #58595b;\n      }\n\n      .st70 {\n        fill: url(#linear-gradient25);\n      }\n\n      .st34 {\n        stroke: #e6e6e6;\n      }\n\n      .st34, .st35 {\n        stroke-width: .5px;\n      }\n\n      .st71 {\n        fill: url(#linear-gradient15);\n      }\n\n      .st72 {\n        fill: url(#linear-gradient17);\n      }\n\n      .st73 {\n        clip-path: url(#clippath-53);\n      }\n\n      .st74 {\n        clip-path: url(#clippath-39);\n      }\n\n      .st75 {\n        fill: url(#linear-gradient6);\n      }\n\n      .st76 {\n        clip-path: url(#clippath-16);\n      }\n\n      .st77 {\n        clip-path: url(#clippath-2);\n      }\n\n      .st78 {\n        clip-path: url(#clippath-29);\n      }\n\n      .st79 {\n        clip-path: url(#clippath-49);\n      }\n\n      .st80 {\n        clip-path: url(#clippath-37);\n      }\n\n      .st81 {\n        clip-path: url(#clippath-13);\n      }\n\n      .st82 {\n        fill: url(#linear-gradient13);\n      }\n\n      .st83 {\n        fill: #0047ba;\n      }\n\n      .st84 {\n        fill: url(#linear-gradient);\n      }\n\n      .st85 {\n        clip-path: url(#clippath-24);\n      }\n\n      .st86 {\n        clip-path: url(#clippath);\n      }\n\n      .st35 {\n        stroke: #58595b;\n      }\n\n      .st87 {\n        clip-path: url(#clippath-44);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 13.8,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 27.59,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 41.39,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 55.19,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 68.98,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 82.78,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 96.58,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 110.37,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 124.17,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 137.97,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 151.76,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 165.56,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 179.36,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 193.15,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 206.95,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 220.75,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 234.54,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 248.34,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 262.14,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 275.93,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 289.73,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 303.53,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 317.32,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 331.12,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 344.92,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 358.71,
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -611.37,
    y1: 556.72,
    x2: -610.37,
    y2: 556.72,
    gradientTransform: "translate(-5371.8298 -82360.4113) rotate(-90) scale(134.9584 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    y: 15,
    width: 9.66,
    height: 134.96
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: -611.63,
    y1: 556.72,
    x2: -610.63,
    y2: 556.72,
    gradientTransform: "translate(-5358.0329 -76701.4497) rotate(-90) scale(125.6509 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 13.8,
    y: 24.31,
    width: 9.66,
    height: 125.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: -611.91,
    y1: 556.72,
    x2: -610.91,
    y2: 556.72,
    gradientTransform: "translate(-5344.2363 -71042.5483) rotate(-90) scale(116.3435 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 27.59,
    y: 33.61,
    width: 9.66,
    height: 116.34
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: -612.02,
    y1: 556.72,
    x2: -611.02,
    y2: 556.72,
    gradientTransform: "translate(-5330.4397 -69156.2278) rotate(-90) scale(113.241 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 41.39,
    y: 36.72,
    width: 9.66,
    height: 113.24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: -612.12,
    y1: 556.72,
    x2: -611.12,
    y2: 556.72,
    gradientTransform: "translate(-5316.643 -67584.3071) rotate(-90) scale(110.6556 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 55.19,
    y: 39.3,
    width: 9.66,
    height: 110.66
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: -612.67,
    y1: 556.72,
    x2: -611.67,
    y2: 556.72,
    gradientTransform: "translate(-5302.8476 -59724.6296) rotate(-90) scale(97.7285 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 68.98,
    y: 52.23,
    width: 9.66,
    height: 97.73
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient6",
    x1: -613.47,
    y1: 556.72,
    x2: -612.47,
    y2: 556.72,
    gradientTransform: "translate(-5289.048 -50921.822) rotate(-90) scale(83.2502 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 82.78,
    y: 66.71,
    width: 9.66,
    height: 83.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient7",
    x1: -613.87,
    y1: 556.72,
    x2: -612.87,
    y2: 556.72,
    gradientTransform: "translate(-5275.2514 -47463.5808) rotate(-90) scale(77.5623 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 96.58,
    y: 72.4,
    width: 9.66,
    height: 77.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient8",
    x1: -614.12,
    y1: 556.72,
    x2: -613.12,
    y2: 556.72,
    gradientTransform: "translate(-5261.4575 -45577.2602) rotate(-90) scale(74.4598 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 110.37,
    y: 75.5,
    width: 9.66,
    height: 74.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient9",
    x1: -615.4,
    y1: 556.72,
    x2: -614.4,
    y2: 556.72,
    gradientTransform: "translate(-5247.6608 -37717.643) rotate(-90) scale(61.5328 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 124.17,
    y: 88.43,
    width: 9.66,
    height: 61.53
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient10",
    x1: -615.47,
    y1: 556.72,
    x2: -614.47,
    y2: 556.72,
    gradientTransform: "translate(-5233.864 -37403.2478) rotate(-90) scale(61.0157 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 137.97,
    y: 88.94,
    width: 9.66,
    height: 61.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient11",
    x1: -615.53,
    y1: 556.72,
    x2: -614.53,
    y2: 556.72,
    gradientTransform: "translate(-5220.0673 -37088.8502) rotate(-90) scale(60.4986 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 151.76,
    y: 89.46,
    width: 9.66,
    height: 60.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient12",
    x1: -616.08,
    y1: 556.72,
    x2: -615.08,
    y2: 556.72,
    gradientTransform: "translate(-5206.2707 -34573.7368) rotate(-90) scale(56.3619 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 165.56,
    y: 93.6,
    width: 9.66,
    height: 56.36
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient13",
    x1: -616.9,
    y1: 556.72,
    x2: -615.9,
    y2: 556.72,
    gradientTransform: "translate(-5192.4738 -31429.8908) rotate(-90) scale(51.1911 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 179.36,
    y: 98.77,
    width: 9.66,
    height: 51.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient14",
    x1: -617.9,
    y1: 556.72,
    x2: -616.9,
    y2: 556.72,
    gradientTransform: "translate(-5178.6772 -28286.0449) rotate(-90) scale(46.0203 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 193.15,
    y: 103.94,
    width: 9.66,
    height: 46.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient15",
    x1: -618.36,
    y1: 556.72,
    x2: -617.36,
    y2: 556.72,
    gradientTransform: "translate(-5164.8803 -27028.5172) rotate(-90) scale(43.952 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 206.95,
    y: 106.01,
    width: 9.66,
    height: 43.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient16",
    x1: -618.49,
    y1: 556.72,
    x2: -617.49,
    y2: 556.72,
    gradientTransform: "translate(-5151.0837 -26714.1196) rotate(-90) scale(43.4349 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 220.75,
    y: 106.52,
    width: 9.66,
    height: 43.43
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient17",
    x1: -619.15,
    y1: 556.72,
    x2: -618.15,
    y2: 556.72,
    gradientTransform: "translate(-5137.2871 -25142.1966) rotate(-90) scale(40.8495 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 234.54,
    y: 109.11,
    width: 9.66,
    height: 40.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient18",
    x1: -619.91,
    y1: 556.72,
    x2: -618.91,
    y2: 556.72,
    gradientTransform: "translate(-5123.4843 -23570.2737) rotate(-90) scale(38.2641 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 248.34,
    y: 111.69,
    width: 9.66,
    height: 38.27
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient19",
    x1: -622.93,
    y1: 556.72,
    x2: -621.93,
    y2: 556.72,
    gradientTransform: "translate(-5109.6877 -18854.4433) rotate(-90) scale(30.5078 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 262.14,
    y: 119.45,
    width: 9.66,
    height: 30.51
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient20",
    x1: -625.62,
    y1: 556.72,
    x2: -624.62,
    y2: 556.72,
    gradientTransform: "translate(-5095.8911 -16024.9937) rotate(-90) scale(25.8541 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 275.93,
    y: 124.1,
    width: 9.66,
    height: 25.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient21",
    x1: -627.58,
    y1: 556.72,
    x2: -626.58,
    y2: 556.72,
    gradientTransform: "translate(-5082.0944 -14453.0708) rotate(-90) scale(23.2687 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 289.73,
    y: 126.69,
    width: 9.66,
    height: 23.27
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient22",
    x1: -628.5,
    y1: 556.72,
    x2: -627.5,
    y2: 556.72,
    gradientTransform: "translate(-5068.2976 -13824.2779) rotate(-90) scale(22.2345 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 303.53,
    y: 127.72,
    width: 9.66,
    height: 22.23
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient23",
    x1: -631.19,
    y1: 556.72,
    x2: -630.19,
    y2: 556.72,
    gradientTransform: "translate(-5054.5009 -12252.3538) rotate(-90) scale(19.6491 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 317.32,
    y: 130.31,
    width: 9.66,
    height: 19.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient24",
    x1: -634.7,
    y1: 556.72,
    x2: -633.7,
    y2: 556.72,
    gradientTransform: "translate(-5040.7041 -10680.4308) rotate(-90) scale(17.0637 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 331.12,
    y: 132.89,
    width: 9.66,
    height: 17.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient25",
    x1: -638.38,
    y1: 556.72,
    x2: -637.38,
    y2: 556.72,
    gradientTransform: "translate(-5026.9074 -9422.9048) rotate(-90) scale(14.9954 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 344.92,
    y: 134.96,
    width: 9.66,
    height: 15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient26",
    x1: -638.38,
    y1: 556.72,
    x2: -637.38,
    y2: 556.72,
    gradientTransform: "translate(-5013.1105 -9422.9048) rotate(-90) scale(14.9954 9.6577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0047ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb4e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    x: 358.71,
    y: 134.96,
    width: 9.66,
    height: 15
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st34",
    y1: 149.96,
    x2: 368.37,
    y2: 149.96
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st34",
    y1: 98.25,
    x2: 368.37,
    y2: 98.25
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st34",
    y1: 46.54,
    x2: 368.37,
    y2: 46.54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M0,149.96V15h9.66v134.96H0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st86"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M0,149.96V15h9.66v134.96H0Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M13.8,149.96V15h9.66v134.96s-9.66,0-9.66,0Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M13.8,149.96V15h9.66v134.96s-9.66,0-9.66,0Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M27.59,149.96V15h9.66v134.96h-9.66Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M27.59,149.96V15h9.66v134.96h-9.66Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M41.39,149.96V15h9.66v134.96h-9.66Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M41.39,149.96V15h9.66v134.96h-9.66Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M55.19,149.96V15h9.66v134.96h-9.66Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M55.19,149.96V15h9.66v134.96h-9.66Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M68.98,149.96V15h9.66v134.96s-9.66,0-9.66,0Z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M68.98,149.96V15h9.66v134.96s-9.66,0-9.66,0Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M82.78,149.96V15h9.66v134.96h-9.66Z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M82.78,149.96V15h9.66v134.96h-9.66Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M96.58,149.96V15h9.66v134.96h-9.66Z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M96.58,149.96V15h9.66v134.96h-9.66Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M110.37,149.96V15h9.66v134.96s-9.66,0-9.66,0Z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M110.37,149.96V15h9.66v134.96s-9.66,0-9.66,0Z"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M124.17,149.96V15h9.66v134.96h-9.66Z"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M124.17,149.96V15h9.66v134.96h-9.66Z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M137.97,149.96V15h9.66v134.96h-9.66Z"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M137.97,149.96V15h9.66v134.96h-9.66Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M151.76,149.96V15h9.66v134.96h-9.66Z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M151.76,149.96V15h9.66v134.96h-9.66Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M165.56,149.96V15h9.66v134.96h-9.66Z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M165.56,149.96V15h9.66v134.96h-9.66Z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M179.36,149.96V15h9.66v134.96h-9.66Z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st81"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M179.36,149.96V15h9.66v134.96h-9.66Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M193.15,149.96V15h9.66v134.96h-9.66Z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M193.15,149.96V15h9.66v134.96h-9.66Z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M206.95,149.96V15h9.66v134.96h-9.66Z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M206.95,149.96V15h9.66v134.96h-9.66Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M220.75,149.96V15h9.66v134.96h-9.66Z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st76"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M220.75,149.96V15h9.66v134.96h-9.66Z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M234.54,149.96V15h9.66v134.96h-9.66Z"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M234.54,149.96V15h9.66v134.96h-9.66Z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M248.34,149.96V15h9.66v134.96h-9.66Z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M248.34,149.96V15h9.66v134.96h-9.66Z"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M262.14,149.96V15h9.66v134.96h-9.66Z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "st64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M262.14,149.96V15h9.66v134.96h-9.66Z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M275.93,149.96V15h9.66v134.96h-9.66Z"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "st49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M275.93,149.96V15h9.66v134.96h-9.66Z"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M289.73,149.96V15h9.66v134.96h-9.66Z"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M289.73,149.96V15h9.66v134.96h-9.66Z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M303.53,149.96V15h9.66v134.96h-9.66Z"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M303.53,149.96V15h9.66v134.96h-9.66Z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M317.32,149.96V15h9.66v134.96h-9.66Z"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M317.32,149.96V15h9.66v134.96h-9.66Z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M331.12,149.96V15h9.66v134.96h-9.66Z"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "st85"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M331.12,149.96V15h9.66v134.96h-9.66Z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M344.92,149.96V15h9.66v134.96h-9.66Z"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M344.92,149.96V15h9.66v134.96h-9.66Z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M358.71,149.96V15h9.66v134.96h-9.66Z"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "st56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M358.71,149.96V15h9.66v134.96h-9.66Z"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M0,149.96V15h9.66v134.96H0Z"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M0,149.96V15h9.66v134.96H0Z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M13.8,149.96V24.31h9.66v125.65s-9.66,0-9.66,0Z"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M13.8,149.96V24.31h9.66v125.65s-9.66,0-9.66,0Z"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.59,149.96V33.61h9.66v116.34h-9.66Z"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    className: "st78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M27.59,149.96V33.61h9.66v116.34h-9.66Z"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M41.39,149.96V36.72h9.66v113.24h-9.66Z"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "st63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M41.39,149.96V36.72h9.66v113.24h-9.66Z"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M55.19,149.96V39.3h9.66v110.66h-9.66Z"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M55.19,149.96V39.3h9.66v110.66h-9.66Z"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M68.98,149.96V52.23h9.66v97.73s-9.66,0-9.66,0Z"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    className: "st68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M68.98,149.96V52.23h9.66v97.73s-9.66,0-9.66,0Z"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M82.78,149.96v-83.25h9.66v83.25h-9.66Z"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M82.78,149.96v-83.25h9.66v83.25h-9.66Z"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M96.58,149.96v-77.56h9.66v77.56h-9.66Z"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M96.58,149.96v-77.56h9.66v77.56h-9.66Z"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M110.37,149.96v-74.46h9.66v74.46s-9.66,0-9.66,0Z"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    className: "st37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M110.37,149.96v-74.46h9.66v74.46s-9.66,0-9.66,0Z"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M124.17,149.96v-61.53h9.66v61.53h-9.66Z"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    className: "st36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M124.17,149.96v-61.53h9.66v61.53h-9.66Z"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M137.97,149.96v-61.02h9.66v61.02h-9.66Z"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    className: "st80"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M137.97,149.96v-61.02h9.66v61.02h-9.66Z"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M151.76,149.96v-60.5h9.66v60.5h-9.66Z"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M151.76,149.96v-60.5h9.66v60.5h-9.66Z"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M165.56,149.96v-56.36h9.66v56.36h-9.66Z"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    className: "st74"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M165.56,149.96v-56.36h9.66v56.36h-9.66Z"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M179.36,149.96v-51.19h9.66v51.19h-9.66Z"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    className: "st47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M179.36,149.96v-51.19h9.66v51.19h-9.66Z"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M193.15,149.96v-46.02h9.66v46.02h-9.66Z"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    className: "st54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M193.15,149.96v-46.02h9.66v46.02h-9.66Z"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M206.95,149.96v-43.95h9.66v43.95h-9.66Z"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M206.95,149.96v-43.95h9.66v43.95h-9.66Z"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M220.75,149.96v-43.43h9.66v43.43h-9.66Z"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M220.75,149.96v-43.43h9.66v43.43h-9.66Z"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M234.54,149.96v-40.85h9.66v40.85h-9.66Z"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    className: "st87"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M234.54,149.96v-40.85h9.66v40.85h-9.66Z"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M248.34,149.96v-38.26h9.66v38.26h-9.66Z"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    className: "st44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M248.34,149.96v-38.26h9.66v38.26h-9.66Z"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M262.14,149.96v-30.51h9.66v30.51h-9.66Z"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    className: "st46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M262.14,149.96v-30.51h9.66v30.51h-9.66Z"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M275.93,149.96v-25.85h9.66v25.85h-9.66Z"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M275.93,149.96v-25.85h9.66v25.85h-9.66Z"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M289.73,149.96v-23.27h9.66v23.27h-9.66Z"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    className: "st38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M289.73,149.96v-23.27h9.66v23.27h-9.66Z"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M303.53,149.96v-22.23h9.66v22.23h-9.66Z"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    className: "st79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M303.53,149.96v-22.23h9.66v22.23h-9.66Z"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M317.32,149.96v-19.65h9.66v19.65h-9.66Z"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    className: "st59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M317.32,149.96v-19.65h9.66v19.65h-9.66Z"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M331.12,149.96v-17.06h9.66v17.06h-9.66Z"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M331.12,149.96v-17.06h9.66v17.06h-9.66Z"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M344.92,149.96v-15h9.66v15h-9.66Z"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    className: "st53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M344.92,149.96v-15h9.66v15h-9.66Z"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M358.71,149.96v-15h9.66v15h-9.66Z"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    className: "st73"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M358.71,149.96v-15h9.66v15h-9.66Z"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M368.37,150.21V15"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st34",
    x1: 368.37,
    y1: 149.96,
    x2: 382.68,
    y2: 149.96
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M373.63,148.33c-.55,0-.98-.24-1.28-.73-.31-.49-.46-1.19-.46-2.1s.15-1.61.46-2.08c.31-.48.73-.71,1.28-.71s.97.24,1.27.71c.31.48.46,1.17.46,2.08s-.15,1.61-.46,2.1-.73.73-1.27.73ZM373.63,147.77c.16,0,.3-.04.43-.13.13-.09.24-.22.33-.41.09-.18.17-.42.22-.71.05-.29.08-.63.08-1.02s-.03-.74-.08-1.02-.12-.51-.22-.69c-.09-.18-.2-.31-.33-.4-.13-.08-.27-.13-.43-.13s-.3.04-.43.13c-.13.08-.24.22-.34.4s-.17.41-.22.69-.08.62-.08,1.02c0,.79.1,1.37.29,1.73.2.36.45.54.77.54h0Z"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M377.3,146.07c-.39,0-.69-.15-.92-.46-.23-.31-.34-.74-.34-1.31s.11-.99.34-1.3c.23-.3.54-.45.92-.45s.69.15.92.45.35.74.35,1.3-.12,1-.35,1.31-.54.46-.92.46ZM377.3,145.64c.21,0,.39-.11.53-.34.14-.22.2-.56.2-1s-.07-.77-.2-.99c-.14-.22-.31-.33-.53-.33s-.4.11-.54.33-.2.55-.2.99.07.77.2,1c.14.22.31.34.54.34ZM377.45,148.33l3.08-5.78h.48l-3.08,5.78h-.48ZM381.19,148.33c-.39,0-.69-.15-.92-.46-.23-.31-.34-.74-.34-1.31s.11-.99.34-1.3c.23-.3.54-.46.92-.46s.69.15.92.46c.23.3.35.74.35,1.3s-.12,1-.35,1.31-.54.46-.92.46ZM381.19,147.9c.21,0,.39-.11.53-.34s.2-.56.2-1-.07-.77-.2-.99-.31-.33-.53-.33-.4.11-.54.33-.2.55-.2.99.07.78.2,1,.31.34.54.34Z"
  }))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st34",
    x1: 368.37,
    y1: 98.25,
    x2: 382.68,
    y2: 98.25
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M372.18,96.52v-.58h1.24v-4h-.99v-.45c.25-.04.47-.1.65-.17.18-.06.35-.14.5-.23h.54v4.84h1.12v.58h-3.06Z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M377.3,94.36c-.38,0-.69-.15-.92-.46s-.34-.74-.34-1.31.12-.99.34-1.3c.23-.3.54-.45.92-.45s.69.15.92.45c.23.3.35.74.35,1.3s-.12,1-.35,1.31-.54.46-.92.46ZM377.3,93.93c.22,0,.39-.11.53-.34.14-.22.2-.56.2-1s-.07-.77-.2-.99c-.14-.22-.31-.33-.53-.33s-.4.11-.54.33-.2.55-.2.99.07.77.2,1c.14.22.31.34.54.34ZM377.46,96.62l3.08-5.78h.48l-3.08,5.78h-.48ZM381.19,96.62c-.39,0-.69-.15-.92-.46s-.34-.74-.34-1.31.12-.99.34-1.3c.23-.3.54-.46.92-.46s.69.15.92.46c.23.3.35.74.35,1.3s-.12,1-.35,1.31-.54.46-.92.46ZM381.19,96.19c.21,0,.39-.11.53-.34.14-.22.2-.56.2-1s-.07-.77-.2-.99c-.14-.22-.31-.33-.53-.33s-.4.11-.54.33-.2.55-.2.99.07.78.2,1c.14.22.31.34.54.34Z"
  }))), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st34",
    x1: 368.37,
    y1: 46.54,
    x2: 382.68,
    y2: 46.54
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M371.85,44.82v-.42c.41-.41.77-.78,1.09-1.11s.58-.63.8-.91.38-.54.49-.77.17-.46.17-.68c0-.31-.08-.57-.25-.77s-.43-.3-.77-.3c-.23,0-.44.06-.63.19-.19.13-.37.28-.53.46l-.4-.4c.23-.25.47-.45.72-.6s.56-.23.92-.23c.5,0,.9.15,1.19.44.29.29.43.68.43,1.16,0,.25-.05.51-.17.77-.11.26-.26.52-.46.8-.2.27-.43.56-.7.86-.27.3-.57.61-.89.95.15,0,.3-.02.46-.03s.31-.02.45-.02h1.57v.6h-3.5.01Z"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M377.3,42.66c-.38,0-.69-.15-.92-.46-.23-.31-.34-.74-.34-1.31s.12-.99.34-1.3c.23-.3.54-.45.92-.45s.69.15.92.45.35.74.35,1.3-.12,1-.35,1.31-.54.46-.92.46ZM377.3,42.22c.22,0,.39-.11.53-.34.14-.22.2-.56.2-1s-.07-.77-.2-.99c-.14-.22-.31-.33-.53-.33s-.4.11-.54.33-.2.55-.2.99.07.77.2,1c.14.22.31.34.54.34ZM377.46,44.92l3.08-5.78h.48l-3.08,5.78h-.48ZM381.19,44.92c-.39,0-.69-.15-.92-.46-.23-.31-.34-.74-.34-1.31s.12-.99.34-1.3c.23-.3.54-.46.92-.46s.69.15.92.46c.23.3.35.74.35,1.3s-.12,1-.35,1.31-.54.46-.92.46ZM381.19,44.48c.21,0,.39-.11.53-.34.14-.22.2-.56.2-1s-.07-.77-.2-.99c-.14-.22-.31-.33-.53-.33s-.4.11-.54.33-.2.55-.2.99.07.78.2,1c.14.22.31.34.54.34Z"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M0,149.96h368.37"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M4.47,13.2l-.26-.26c0-.51,0-.97-.01-1.37,0-.4-.03-.76-.07-1.07-.04-.31-.1-.57-.18-.79-.08-.22-.18-.4-.32-.53-.2-.19-.41-.3-.64-.32-.23-.02-.45.08-.67.3-.14.14-.23.31-.27.51s-.05.41-.04.62h-.5c0-.3,0-.57.08-.82.06-.25.21-.49.43-.71.31-.31.65-.47,1.02-.47s.69.15.99.45c.16.16.29.35.38.58s.16.49.21.79c.05.29.08.62.1.97s.03.74.04,1.15c.08-.1.17-.2.26-.31s.18-.2.27-.29l.98-.98.38.38-2.18,2.19v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M8.15,11.32l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.08.08-.18.13-.3.14-.11.01-.22-.03-.32-.13-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13s.32.12.47.28c.23.23.37.49.41.78s0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M9.7,8.1c-.17.17-.35.29-.56.36s-.43.1-.67.06c-.24-.03-.49-.12-.76-.26-.26-.14-.53-.35-.8-.62-.34-.34-.59-.66-.76-.97-.17-.31-.27-.6-.3-.87s0-.52.08-.74.21-.42.38-.59c.18-.18.38-.31.58-.37s.4-.09.6-.09l.03.51c-.15-.01-.3,0-.45.06-.14.05-.27.13-.38.23-.12.12-.2.25-.26.41-.06.16-.07.33-.04.53s.11.41.25.64c.13.23.33.48.6.76-.02-.24,0-.46.06-.68.07-.22.17-.39.3-.53.29-.29.61-.44.96-.44s.7.17,1.05.52c.16.16.28.34.36.52.08.19.12.37.12.56s-.03.37-.09.54-.17.33-.31.47h.01ZM9.35,7.75c.08-.08.14-.18.18-.29s.05-.22.03-.34c-.01-.12-.05-.24-.11-.36-.06-.12-.15-.24-.26-.35-.22-.22-.45-.35-.68-.37-.23-.02-.45.07-.66.28-.11.11-.19.26-.25.46-.06.2-.06.43,0,.69.36.3.69.48.99.52.3.05.55-.04.77-.25h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M11.27,6.4l-.36-.36.77-.77-2.49-2.49-.62.62-.28-.28c.13-.18.23-.35.3-.51.08-.16.13-.31.17-.46l.33-.33,3.02,3.02.7-.7.36.36-1.91,1.91h.01Z"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M18.26,22.5l-.26-.26c0-.51,0-.97-.01-1.37,0-.4-.03-.76-.07-1.07-.04-.31-.1-.57-.18-.79-.08-.22-.18-.4-.32-.53-.2-.19-.41-.3-.64-.32s-.45.08-.67.3c-.14.14-.23.31-.27.51-.04.2-.05.41-.04.62h-.5c-.01-.3.01-.57.08-.82.06-.25.21-.49.43-.71.31-.31.65-.47,1.02-.47s.69.15.99.45c.16.16.29.35.38.58.09.23.16.49.21.79.05.29.08.62.1.97.02.35.03.74.04,1.15.08-.1.17-.2.26-.31s.18-.2.27-.29l.98-.98.38.38-2.18,2.19v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M21.94,20.63l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.08.08-.18.13-.3.14-.11.01-.22-.03-.32-.13-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13s.32.12.47.28c.23.23.37.49.41.78.04.29,0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M23.62,17.15l-.93-.93-1.52,1.52-.29-.29-.72-3.61.49-.49,2.1,2.1.46-.46.35.35-.46.46.93.93-.41.41h0ZM21.28,16.93l1.06-1.06-.98-.98c-.09-.09-.2-.2-.32-.33-.12-.13-.22-.25-.31-.34l-.02.02c.04.12.07.25.11.37.03.12.06.25.09.38l.37,1.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M25.96,14.94c-.13.13-.27.24-.41.33-.14.08-.28.15-.41.2-.14.05-.27.08-.4.1s-.25.02-.37.01l-.06-.51c.21,0,.42-.02.64-.08.22-.05.43-.18.63-.38.21-.21.32-.43.34-.67s-.07-.46-.26-.65c-.1-.1-.21-.17-.33-.22s-.25-.06-.4-.03c-.14.02-.3.09-.47.2s-.35.26-.56.46l-.33-.33c.18-.18.32-.35.41-.5s.14-.3.16-.43,0-.25-.04-.36-.11-.21-.2-.3c-.17-.17-.35-.24-.55-.24s-.39.1-.57.28c-.14.14-.24.3-.29.49-.05.18-.08.38-.08.58l-.51-.04c0-.25.05-.5.13-.74s.22-.46.42-.66c.15-.15.3-.27.47-.35.16-.08.33-.14.49-.15.16-.02.32,0,.48.06s.3.15.44.29c.21.21.32.43.33.67.02.24-.03.49-.14.75l.02.02c.13-.08.26-.14.39-.18.14-.04.28-.06.41-.05.14,0,.28.04.41.1s.26.14.37.26c.15.15.25.31.32.49.06.18.08.36.07.54s-.07.36-.16.54-.21.35-.37.5h-.02Z"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M32.06,31.81l-.26-.26c0-.51,0-.97-.01-1.37,0-.4-.03-.76-.07-1.07-.04-.31-.1-.57-.18-.79-.08-.22-.18-.4-.32-.53-.2-.19-.41-.3-.64-.32s-.45.08-.67.3c-.14.14-.23.31-.27.51s-.05.41-.04.62h-.5c-.01-.3.01-.57.08-.82.06-.25.21-.49.43-.71.31-.31.65-.47,1.02-.47s.69.15.99.45c.16.16.29.35.38.58.09.23.16.49.21.79.05.29.08.62.1.97.02.35.03.74.04,1.15.08-.1.17-.2.26-.31s.18-.2.27-.29l.98-.98.38.38-2.18,2.19v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M35.74,29.93l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.08.08-.18.13-.3.14-.11.01-.22-.03-.32-.13-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13s.32.12.47.28c.23.23.37.49.41.78s0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M36.02,27.86l-.26-.26v-1.37c0-.4-.03-.76-.07-1.07s-.1-.57-.17-.79c-.08-.22-.18-.4-.32-.53-.19-.19-.41-.3-.64-.32s-.45.08-.67.3c-.14.14-.23.31-.27.51s-.05.41-.04.62h-.5c0-.3,0-.57.08-.82s.21-.49.43-.71c.32-.31.65-.47,1.02-.47s.69.15,1,.45c.16.16.28.35.38.58.09.23.16.49.21.79.05.29.08.62.1.97.02.35.03.74.04,1.15.08-.1.17-.2.26-.31s.18-.2.27-.29l.98-.98.38.38-2.19,2.19-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M39.74,24.25c-.13.13-.27.24-.41.33-.14.08-.27.15-.41.2-.13.05-.26.08-.39.1s-.25.02-.37.02l-.08-.5c.2,0,.41-.02.62-.08s.42-.19.62-.38c.1-.1.18-.22.23-.34.05-.13.08-.26.08-.39s-.03-.27-.09-.4-.14-.26-.26-.38c-.23-.23-.48-.35-.74-.35s-.5.11-.72.33c-.12.12-.2.23-.25.35s-.09.26-.12.43l-.38.08-1.52-1.74,1.69-1.69.38.38-1.31,1.31.91,1.09c.04-.12.09-.24.14-.35.06-.11.14-.21.24-.31.15-.15.3-.26.47-.35.17-.08.35-.13.53-.14.18,0,.37.03.55.1.19.08.37.21.56.39.19.18.32.38.39.58.08.21.11.41.1.61,0,.2-.05.4-.14.59-.08.19-.2.36-.35.5h.03Z"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M45.86,34.91l-.26-.26c0-.51,0-.97,0-1.37,0-.4-.03-.76-.07-1.07-.04-.31-.1-.57-.18-.79-.08-.22-.18-.4-.32-.53-.2-.19-.41-.3-.64-.32s-.45.08-.67.3c-.14.14-.23.31-.27.51s-.05.41-.04.62h-.5c0-.3,0-.57.08-.82.06-.25.21-.49.43-.71.31-.31.65-.47,1.02-.47s.69.15.99.45c.16.16.29.35.38.58s.16.49.21.79c.05.29.08.62.1.97.02.35.03.74.04,1.15.08-.1.17-.2.26-.31s.18-.2.27-.29l.98-.98.38.38-2.18,2.19v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M49.54,33.04l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.08.08-.18.13-.3.14-.11.01-.22-.03-.32-.13-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13s.32.12.47.28c.23.23.37.49.41.78s0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M50.02,30.75l-.36-.36.77-.77-2.49-2.49-.62.62-.28-.28c.13-.18.23-.35.3-.51.08-.15.13-.31.17-.46l.33-.33,3.02,3.02.7-.7.36.36-1.91,1.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M53.39,27.51c-.18.18-.37.3-.57.37s-.4.1-.6.09l-.03-.52c.15.01.3,0,.45-.06.15-.05.27-.12.38-.23.12-.12.21-.26.26-.41.06-.15.07-.33.04-.53s-.12-.41-.25-.64-.34-.49-.6-.76c.03.24,0,.47-.05.69-.06.22-.17.4-.31.54-.29.29-.61.44-.96.44s-.69-.18-1.04-.53c-.16-.16-.28-.34-.36-.52-.08-.19-.12-.37-.13-.56,0-.19.03-.37.09-.54s.17-.33.3-.46c.17-.17.36-.29.57-.36.21-.08.44-.1.68-.07s.49.12.75.26.53.35.8.63c.34.34.59.66.76.97s.27.6.3.87,0,.52-.08.74-.21.42-.38.59h-.02ZM51.84,25.64c.11-.11.2-.27.25-.46.05-.2.06-.43,0-.7-.36-.3-.69-.48-.99-.52s-.55.04-.77.26c-.08.08-.14.18-.18.28-.04.11-.05.22-.04.34s.05.24.11.36.15.24.26.35c.22.22.45.35.68.37s.45-.07.66-.28h.02Z"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M59.65,37.5l-.26-.26c0-.51,0-.97,0-1.37,0-.4-.03-.76-.07-1.07s-.1-.57-.18-.79-.18-.4-.32-.53c-.2-.19-.41-.3-.64-.32s-.45.08-.67.3c-.14.14-.23.31-.27.51-.04.2-.05.41-.04.62h-.5c0-.3,0-.57.08-.82.06-.25.21-.49.43-.71.31-.31.65-.47,1.02-.47s.69.15.99.45c.16.16.29.35.38.58.09.23.16.49.21.79.05.29.08.62.1.97.02.35.03.74.04,1.15.08-.1.17-.2.26-.31s.18-.2.27-.29l.98-.98.38.38-2.18,2.19v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M63.33,35.62l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,0-.02.03-.05.06-.08.08-.18.13-.3.14-.11,0-.22-.03-.32-.13-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13s.32.12.47.28c.23.23.37.49.41.78.04.29,0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M63.82,33.34l-.36-.36.77-.77-2.49-2.49-.62.62-.28-.28c.13-.18.23-.35.3-.51.08-.15.13-.31.17-.46l.33-.33,3.02,3.02.7-.7.36.36-1.91,1.91h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M67.65,29.51l-.93-.93-1.52,1.52-.29-.29-.72-3.61.49-.49,2.1,2.1.46-.46.35.35-.46.46.93.93-.41.41h0ZM65.3,29.29l1.06-1.06-.98-.98c-.09-.09-.2-.2-.32-.33s-.22-.25-.31-.34l-.02.02c.04.12.07.25.11.37.03.12.06.25.09.38l.37,1.95h0Z"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M73.66,50.22l-.36-.36.77-.77-2.49-2.49-.62.62-.28-.28c.13-.18.23-.35.3-.51.07-.15.13-.31.17-.46l.33-.33,3.02,3.02.7-.7.36.36-1.91,1.91h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M77.13,48.55l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,0-.02.03-.05.06-.08.08-.18.13-.3.14-.11,0-.22-.03-.32-.13-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13s.32.12.47.28c.23.23.37.49.41.78.04.29,0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M78.58,45.42c-.16.16-.33.28-.51.37s-.36.14-.54.16c-.18,0-.36,0-.53-.06s-.32-.15-.46-.29c-.11-.11-.19-.23-.25-.36s-.09-.26-.11-.4-.02-.27,0-.4.05-.26.08-.39l-.02-.02c-.21.04-.43.04-.65,0-.22-.03-.42-.14-.6-.32-.13-.13-.22-.27-.28-.43s-.08-.31-.07-.48c0-.16.05-.32.12-.48s.18-.31.32-.45c.15-.15.3-.26.46-.33.16-.07.32-.11.49-.11.16,0,.32.03.48.1s.3.17.43.3c.09.09.16.19.21.3.05.11.09.22.12.34.03.11.04.23.04.34s0,.21-.02.31l.02.02c.12-.03.24-.06.36-.07.13-.02.25-.02.37,0,.12,0,.25.05.37.1.12.06.24.14.35.25.13.13.22.27.28.43s.08.33.06.51c-.02.18-.07.36-.15.54-.09.18-.21.35-.38.51h0ZM76.91,43.27c.01-.22,0-.41-.06-.59s-.14-.32-.26-.45c-.17-.17-.36-.26-.58-.27-.22,0-.42.07-.61.26-.16.16-.24.34-.24.54s.08.39.24.55c.1.1.21.17.33.2s.24.04.37.02c.13-.02.26-.05.4-.1s.28-.11.42-.17h-.01ZM78.27,45.09c.2-.2.3-.41.32-.64.01-.23-.07-.44-.25-.61-.11-.11-.23-.18-.36-.21s-.26-.03-.41,0c-.14.03-.29.07-.45.13-.16.06-.32.13-.49.2-.04.23-.05.45-.02.66.03.21.12.4.28.55.1.1.2.16.32.2s.23.06.36.05c.12,0,.25-.04.37-.1.12-.06.23-.14.33-.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M80.98,43.02c-.18.18-.37.3-.57.37s-.4.1-.6.09l-.03-.52c.15,0,.3,0,.45-.06.15-.05.27-.12.38-.23.12-.12.21-.26.26-.41.06-.15.07-.33.04-.53-.03-.2-.12-.41-.25-.64s-.34-.49-.6-.76c.03.24,0,.47-.05.69-.06.22-.17.4-.31.54-.29.29-.61.44-.96.44s-.69-.18-1.04-.53c-.16-.16-.28-.34-.36-.52-.08-.19-.12-.37-.13-.56,0-.19.03-.37.09-.54s.17-.33.3-.46c.17-.17.36-.29.57-.36.21-.08.44-.1.68-.07s.49.12.75.26.53.35.8.63c.34.34.59.66.76.97.17.31.27.6.3.87.03.27,0,.52-.08.74s-.21.42-.38.59h-.02ZM79.43,41.16c.11-.11.2-.27.25-.46.05-.2.06-.43,0-.7-.36-.3-.69-.48-.99-.52s-.55.04-.77.26c-.08.08-.14.18-.18.28-.04.11-.05.22-.04.34s.05.24.11.36.15.24.26.35c.22.22.45.35.68.37s.45-.07.66-.28h.02Z"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M87.45,64.89l-.36-.36.77-.77-2.49-2.49-.62.62-.28-.28c.13-.18.23-.35.3-.51.07-.15.13-.31.17-.46l.33-.33,3.02,3.02.7-.7.36.36-1.91,1.91h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M90.93,63.22l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,0-.02.03-.05.06-.08.08-.18.13-.3.14-.11,0-.22-.03-.32-.13-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13s.32.12.47.28c.23.23.37.49.41.78.04.29,0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M92.48,59.99c-.17.17-.35.29-.56.36s-.43.1-.67.06c-.24-.03-.49-.12-.76-.26-.26-.14-.53-.35-.8-.62-.34-.34-.59-.66-.76-.97-.17-.31-.27-.6-.3-.87-.03-.27,0-.52.08-.74s.21-.42.38-.59c.18-.18.38-.31.58-.37.2-.06.4-.09.6-.09l.03.51c-.15,0-.3,0-.45.06-.14.05-.27.13-.38.23-.12.12-.2.25-.26.41-.06.16-.07.33-.04.53s.11.41.25.64c.13.23.33.48.6.76-.02-.24,0-.46.06-.68.07-.22.17-.39.3-.53.29-.29.61-.44.96-.44s.7.17,1.05.52c.16.16.28.34.36.52.08.19.12.37.12.56s-.03.37-.09.54-.17.33-.31.47h0ZM92.13,59.65c.08-.08.14-.18.18-.29s.05-.22.03-.34c-.01-.12-.05-.24-.11-.36s-.15-.24-.26-.35c-.22-.22-.45-.35-.68-.37s-.45.07-.66.28c-.11.11-.19.26-.25.46s-.06.43,0,.69c.36.3.69.48.99.52.3.05.55-.04.77-.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M94.05,58.3l-.36-.36.77-.77-2.49-2.49-.62.62-.28-.28c.13-.18.23-.35.3-.51.08-.16.13-.31.17-.46l.33-.33,3.02,3.02.7-.7.36.36-1.91,1.91h.01Z"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M101.25,70.39l-.36-.36.77-.77-2.49-2.49-.62.62-.28-.28c.13-.18.23-.35.3-.51.07-.15.13-.31.17-.46l.33-.33,3.02,3.02.7-.7.36.36-1.91,1.91h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M104.72,68.72l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.08.08-.18.13-.3.14-.11.01-.22-.03-.32-.13-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13s.32.12.47.28c.23.23.37.49.41.78s0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M106.09,65.67c-.13.13-.27.24-.41.33-.14.08-.27.15-.41.2-.13.05-.26.08-.39.1s-.25.02-.37.02l-.07-.5c.2,0,.41-.02.62-.08.21-.06.42-.19.62-.38.1-.1.18-.22.23-.34.05-.13.08-.26.08-.39s-.03-.27-.08-.4c-.06-.13-.14-.26-.26-.38-.23-.23-.48-.35-.74-.35s-.5.11-.72.33c-.12.12-.2.23-.25.35s-.09.26-.12.43l-.38.08-1.52-1.74,1.69-1.69.38.38-1.31,1.31.91,1.09c.04-.12.09-.24.14-.35.06-.11.14-.21.24-.31.14-.15.3-.26.47-.35.17-.08.34-.13.53-.14.18,0,.37.03.55.1.19.08.37.21.56.39.18.18.31.38.39.58.08.21.11.41.1.61,0,.2-.06.4-.14.59-.09.19-.2.36-.35.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M108.81,62.96c-.34.34-.76.46-1.26.35s-1.03-.46-1.6-1.02c-.57-.57-.91-1.1-1.01-1.59s.01-.9.35-1.25c.34-.34.75-.46,1.24-.35s1.02.44,1.59,1.01.91,1.1,1.02,1.6c.11.49,0,.91-.34,1.25h.01ZM108.46,62.61c.1-.1.16-.22.19-.35.03-.13,0-.29-.05-.46-.06-.17-.16-.37-.31-.58-.15-.21-.34-.44-.59-.69s-.48-.44-.68-.59-.4-.24-.57-.3c-.17-.05-.32-.07-.45-.04s-.25.09-.35.19-.16.22-.19.35c-.03.13-.02.29.04.46.05.17.15.36.3.57.14.21.34.44.59.68.5.5.92.79,1.26.9.35.1.62.05.82-.14h-.01Z"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M115.05,73.49l-.36-.36.77-.77-2.49-2.49-.62.62-.28-.28c.13-.18.23-.35.3-.51.07-.15.13-.31.16-.46l.33-.33,3.02,3.02.7-.7.36.36-1.91,1.91h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M118.52,71.82l-.36-.15c.09-.22.12-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.08.08-.18.13-.3.14-.11.01-.22-.03-.32-.13s-.14-.2-.13-.32c0-.12.06-.22.14-.31.11-.11.25-.16.41-.13.16.03.32.12.47.28.23.23.37.49.41.78s0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M120.2,68.34l-.93-.93-1.52,1.52-.29-.29-.71-3.61.49-.49,2.1,2.1.46-.46.35.35-.46.46.93.93-.41.41h0ZM117.85,68.12l1.06-1.06-.98-.98c-.09-.09-.2-.2-.32-.33-.12-.13-.22-.25-.31-.34l-.02.02c.04.12.07.25.11.37.03.12.06.25.09.38l.37,1.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M122.83,65.7l-.93-.93-1.52,1.52-.29-.29-.72-3.61.49-.49,2.1,2.1.46-.46.35.35-.46.46.93.93-.41.41h0ZM120.49,65.48l1.06-1.06-.98-.98c-.09-.09-.2-.2-.32-.33s-.22-.25-.31-.34l-.02.02c.04.12.07.25.11.37.03.12.06.25.1.38l.37,1.95h-.01Z"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M128.84,86.93l-.36-.36.77-.77-2.49-2.49-.62.62-.28-.28c.13-.18.23-.35.3-.51.07-.15.13-.31.16-.46l.33-.33,3.02,3.02.7-.7.36.36-1.91,1.91h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M132.32,85.26l-.36-.15c.09-.22.12-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.08.08-.18.13-.3.14-.11.01-.22-.03-.32-.13s-.14-.2-.13-.32c0-.12.06-.22.14-.31.11-.11.25-.16.41-.13.16.03.32.12.47.28.23.23.37.49.41.78.04.29,0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M132.8,82.98l-.36-.36.78-.77-2.49-2.49-.62.62-.28-.28c.13-.18.23-.35.3-.51.08-.15.13-.31.17-.46l.33-.33,3.02,3.02.7-.7.36.36-1.91,1.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M136.17,79.74c-.18.18-.37.3-.57.37s-.4.1-.6.09l-.03-.52c.15.01.3,0,.45-.06.15-.05.27-.12.38-.23.12-.12.21-.26.26-.41.06-.15.07-.33.04-.53-.03-.2-.12-.41-.25-.64s-.34-.49-.6-.76c.03.24,0,.47-.05.69-.06.22-.17.4-.31.54-.29.29-.61.44-.96.44s-.7-.18-1.04-.53c-.16-.16-.28-.34-.36-.52s-.12-.37-.13-.56c0-.19.03-.37.1-.54s.17-.33.3-.46c.17-.17.36-.29.56-.36.21-.08.44-.1.68-.07.24.03.49.12.75.26s.53.35.8.63c.34.34.59.66.76.97s.27.6.3.87c.03.27,0,.52-.08.74-.09.22-.21.42-.38.59h-.02ZM134.62,77.87c.11-.11.2-.27.25-.46.05-.2.06-.43,0-.7-.36-.3-.69-.48-.99-.52-.3-.04-.55.04-.77.26-.08.08-.14.18-.18.28-.04.11-.05.22-.04.34,0,.12.05.24.11.36s.15.24.26.35c.22.22.45.35.68.37s.45-.07.66-.28h.02Z"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M142.64,86.93l-.36-.36.77-.77-2.49-2.49-.62.62-.28-.28c.13-.18.23-.35.3-.51.07-.15.13-.31.17-.46l.33-.33,3.02,3.02.7-.7.36.36-1.91,1.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M146.11,85.26l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.08.08-.18.13-.3.14-.11.01-.22-.03-.32-.13-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13s.32.12.47.28c.23.23.37.49.41.78.04.29,0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M146.6,82.98l-.36-.36.77-.77-2.49-2.49-.62.62-.28-.28c.13-.18.23-.35.3-.51.08-.15.13-.31.17-.46l.33-.33,3.02,3.02.7-.7.36.36-1.91,1.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M150.2,79.5c-.16.16-.33.28-.51.37-.18.09-.36.14-.54.16-.18.01-.36,0-.52-.06-.17-.06-.32-.15-.46-.29-.11-.11-.19-.23-.25-.36s-.09-.26-.11-.4c-.02-.13-.02-.27,0-.4.02-.13.05-.26.08-.39l-.02-.02c-.21.04-.43.04-.65,0-.22-.03-.42-.14-.6-.32-.13-.13-.22-.27-.28-.43s-.08-.31-.07-.48c0-.16.05-.32.12-.48s.18-.31.32-.45c.15-.15.3-.26.46-.33s.32-.11.49-.11c.16,0,.32.03.48.1.15.07.3.17.43.3.09.09.16.19.21.3s.09.22.12.34c.03.11.04.23.04.34s0,.21-.02.31l.02.02c.12-.03.24-.06.36-.07.13-.02.25-.02.37,0,.12.01.25.05.37.1.12.06.24.14.35.25.13.13.22.27.28.43s.08.33.06.51c0,.18-.06.36-.15.54s-.21.35-.38.51h0ZM148.53,77.35c0-.22,0-.41-.06-.59-.05-.17-.14-.32-.26-.45-.17-.17-.36-.26-.58-.27-.22-.01-.42.07-.61.26-.16.16-.24.34-.24.54s.08.39.24.55c.1.1.21.17.33.2.11.03.24.04.37.02.13-.02.26-.05.4-.1.14-.05.28-.11.42-.17h0ZM149.89,79.16c.2-.2.3-.41.32-.64,0-.23-.07-.44-.25-.61-.11-.11-.23-.18-.36-.21s-.26-.03-.41,0c-.14.03-.29.07-.45.13s-.32.13-.49.2c-.04.23-.05.45-.02.66.03.21.12.4.28.55.1.1.2.16.32.2.11.04.23.06.36.05.12,0,.25-.04.37-.1s.23-.14.33-.24h0Z"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M156.44,87.45l-.36-.36.77-.77-2.49-2.49-.62.62-.28-.28c.13-.18.23-.35.3-.51.07-.15.13-.31.17-.46l.33-.33,3.02,3.02.7-.7.36.36-1.91,1.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M159.91,85.78l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.08.08-.18.13-.3.14-.11.01-.22-.03-.32-.13-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13s.32.12.47.28c.23.23.37.49.41.78.04.29,0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M160.39,83.49l-.36-.36.77-.77-2.49-2.49-.62.62-.28-.28c.13-.18.23-.35.3-.51.08-.15.13-.31.17-.46l.33-.33,3.02,3.02.7-.7.36.36-1.91,1.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M163.55,80.34c-.3-.33-.57-.65-.79-.96-.22-.31-.42-.62-.58-.93s-.29-.64-.4-.98c-.1-.34-.19-.71-.26-1.11l-1.69,1.69-.38-.38,2.18-2.18.27.27c.05.46.13.86.24,1.22s.25.7.41,1.01c.17.32.37.63.61.93s.51.63.83.97l-.45.45h0Z"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M170.23,91.59l-.36-.36.77-.77-2.49-2.49-.62.62-.28-.28c.13-.18.23-.35.3-.51.07-.15.13-.31.17-.46l.33-.33,3.02,3.02.7-.7.36.36-1.91,1.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M173.71,89.92l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.08.08-.18.13-.3.14-.11.01-.22-.03-.32-.13-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13s.32.12.47.28c.23.23.37.49.41.78.04.29,0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M175.16,86.79c-.34.34-.76.46-1.26.35s-1.03-.45-1.6-1.02-.91-1.1-1.01-1.59,0-.9.36-1.25c.34-.34.75-.46,1.24-.35s1.02.44,1.59,1.01c.57.57.91,1.1,1.02,1.6.11.49,0,.91-.34,1.25h0ZM174.81,86.44c.1-.1.16-.22.19-.35s0-.29-.05-.46c-.06-.17-.16-.37-.31-.58s-.34-.44-.59-.69-.48-.44-.68-.59-.4-.24-.57-.3c-.17-.05-.32-.07-.45-.04-.13.03-.25.09-.35.19-.1.1-.16.22-.19.35s-.02.29.04.46c.05.17.15.36.3.57.15.21.34.44.59.68.5.5.92.79,1.26.9.35.1.62.05.82-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M177.56,84.39c-.18.18-.37.3-.57.37s-.4.1-.6.09l-.03-.52c.15.01.3,0,.45-.06.15-.05.27-.12.38-.23.12-.12.21-.26.26-.41.06-.15.07-.33.04-.53-.03-.2-.12-.41-.25-.64s-.34-.49-.6-.76c.03.24,0,.47-.05.69-.06.22-.17.4-.31.54-.29.29-.61.44-.96.44s-.69-.18-1.04-.53c-.16-.16-.28-.34-.36-.52-.08-.19-.12-.37-.13-.56,0-.19.03-.37.09-.54s.17-.33.3-.46c.17-.17.36-.29.57-.36.21-.08.44-.1.68-.07.24.03.49.12.75.26s.53.35.8.63c.34.34.59.66.76.97s.27.6.3.87c.03.27,0,.52-.08.74s-.21.42-.38.59h-.02ZM176.01,82.52c.11-.11.2-.27.25-.46.05-.2.06-.43,0-.7-.36-.3-.69-.48-.99-.52s-.55.04-.77.26c-.08.08-.14.18-.18.28-.04.11-.05.22-.04.34,0,.12.05.24.11.36s.15.24.26.35c.22.22.45.35.68.37.23.02.45-.07.66-.28h.02Z"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M185,95.92c-.34.34-.76.46-1.26.35s-1.03-.45-1.6-1.02-.91-1.1-1.01-1.59c-.11-.49,0-.9.35-1.25.34-.34.75-.46,1.24-.35s1.02.44,1.59,1.01c.57.57.91,1.1,1.02,1.6.11.49,0,.91-.34,1.25h0ZM184.65,95.57c.1-.1.16-.22.19-.35.02-.13,0-.29-.05-.46-.06-.17-.16-.37-.31-.58s-.34-.44-.59-.69-.47-.44-.68-.59-.4-.24-.57-.3c-.17-.05-.32-.07-.46-.04-.13.03-.25.09-.35.19-.1.1-.16.22-.19.35s-.02.29.04.46c.05.17.15.36.3.57s.34.44.59.68c.5.5.92.79,1.26.9.35.1.62.05.82-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M187.5,95.09l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.09.08-.19.13-.3.14s-.22-.03-.32-.13c-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13.16.03.32.12.47.28.23.23.37.49.41.78.04.29,0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M188.72,92.2c-.18.18-.37.31-.58.37-.2.07-.4.1-.6.09l-.03-.52c.15.01.3,0,.45-.06.15-.05.27-.12.38-.23.12-.12.21-.26.27-.41s.07-.33.03-.53c-.03-.2-.12-.41-.25-.64s-.34-.49-.61-.76c.03.24,0,.47-.05.69s-.17.4-.31.54c-.29.29-.61.44-.96.44s-.7-.18-1.04-.53c-.16-.16-.28-.34-.36-.52s-.12-.37-.13-.56c0-.19.03-.37.1-.54.07-.18.17-.33.3-.46.17-.17.36-.29.56-.36.21-.08.44-.1.68-.07.24.03.49.12.75.26s.53.35.8.63c.34.34.59.66.76.97s.27.6.3.87c.03.27,0,.52-.08.74s-.21.42-.38.59h0ZM187.17,90.33c.11-.11.2-.27.25-.46.05-.2.06-.43,0-.7-.36-.3-.69-.48-.99-.52s-.55.04-.77.26c-.08.08-.14.18-.18.28-.04.11-.05.22-.04.34,0,.12.05.24.11.36s.15.24.26.35c.22.22.45.35.68.37.23.02.45-.07.66-.28h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M191.35,89.56c-.18.18-.37.3-.57.37s-.4.1-.6.09l-.03-.52c.15.01.3,0,.45-.06.15-.05.28-.12.38-.23.12-.12.21-.26.26-.41.06-.15.07-.33.04-.53-.03-.2-.12-.41-.25-.64s-.34-.49-.6-.76c.03.24,0,.47-.05.69-.06.22-.17.4-.31.54-.29.29-.61.44-.96.44s-.69-.18-1.04-.53c-.16-.16-.28-.34-.36-.52-.08-.19-.12-.37-.13-.56,0-.19.03-.37.09-.54s.17-.33.3-.46c.17-.17.36-.29.57-.36.21-.08.44-.1.68-.07.24.03.49.12.75.26s.53.35.8.63c.34.34.59.66.76.97s.27.6.3.87c.03.27,0,.52-.08.74s-.21.42-.38.59h-.02ZM189.81,87.69c.11-.11.2-.27.25-.46.05-.2.06-.43,0-.7-.36-.3-.69-.48-.98-.52-.3-.04-.55.04-.77.26-.08.08-.14.18-.18.28-.04.11-.05.22-.04.34,0,.12.05.24.11.36s.15.24.26.35c.22.22.45.35.68.37.23.02.45-.07.66-.28h0Z"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M198.79,100.76c-.34.34-.76.46-1.26.35s-1.03-.45-1.6-1.02-.91-1.1-1.01-1.59c-.11-.49,0-.9.35-1.25.34-.34.75-.46,1.24-.35s1.02.44,1.59,1.01c.57.57.91,1.1,1.02,1.6.11.49,0,.91-.34,1.25h0ZM198.44,100.41c.1-.1.16-.22.19-.35.02-.13,0-.29-.05-.46-.06-.17-.16-.37-.31-.58s-.34-.44-.59-.69-.47-.44-.68-.59-.4-.24-.57-.3c-.17-.05-.32-.07-.46-.04-.13.03-.25.09-.35.19-.1.1-.16.22-.19.35s-.02.29.04.46c.05.17.15.36.3.57s.34.44.59.68c.5.5.92.79,1.26.9.35.1.62.05.82-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M201.3,99.93l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.09.08-.19.13-.3.14s-.22-.03-.32-.13c-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13.16.03.32.12.47.28.23.23.37.49.41.78.04.29,0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M202.75,96.8c-.16.16-.33.28-.51.37-.18.09-.36.14-.54.16s-.36,0-.53-.06-.32-.15-.46-.29c-.11-.11-.19-.23-.25-.36s-.09-.26-.11-.4-.02-.27,0-.4c.02-.13.04-.26.08-.39l-.02-.02c-.21.04-.43.04-.65,0-.22-.03-.42-.14-.6-.32-.13-.13-.22-.27-.28-.43s-.08-.31-.07-.48c0-.16.05-.32.12-.48s.18-.31.32-.45c.15-.15.3-.26.46-.33s.32-.11.49-.11c.16,0,.32.03.48.1.15.07.3.17.43.3.09.09.16.19.21.3s.09.22.12.34c.03.11.04.23.04.34s0,.21-.02.31l.02.02c.12-.03.24-.06.36-.07.13-.02.25-.02.38,0,.12.01.25.05.37.1.12.06.24.14.35.25.13.13.22.27.28.43s.08.33.06.51-.07.36-.15.54c-.09.18-.21.35-.38.51h0ZM201.08,94.65c0-.22,0-.41-.06-.59-.05-.18-.14-.32-.26-.45-.17-.17-.36-.26-.58-.27-.22-.01-.42.07-.61.26-.16.16-.24.34-.24.54s.08.39.24.55c.1.1.21.17.33.2s.24.04.37.02c.13-.02.26-.05.4-.1.14-.05.28-.11.42-.17h0ZM202.44,96.47c.2-.2.3-.41.32-.64,0-.23-.07-.44-.25-.61-.11-.11-.23-.18-.36-.21s-.26-.03-.4,0-.29.07-.46.13c-.16.06-.32.13-.49.2-.04.23-.05.45-.02.66.03.21.12.4.28.55.1.1.2.16.31.2.12.04.23.06.36.05.12,0,.24-.04.37-.1.12-.06.23-.14.33-.24h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M205.15,94.4c-.18.18-.37.3-.57.37s-.4.1-.6.09l-.03-.52c.15.01.3,0,.45-.06.15-.05.28-.12.38-.23.12-.12.21-.26.26-.41.06-.15.07-.33.04-.53-.03-.2-.12-.41-.25-.64s-.34-.49-.6-.76c.03.24,0,.47-.05.69-.06.22-.17.4-.31.54-.29.29-.61.44-.96.44s-.69-.18-1.04-.53c-.16-.16-.28-.34-.36-.52-.08-.19-.12-.37-.13-.56,0-.19.03-.37.09-.54s.17-.33.3-.46c.17-.17.36-.29.57-.36.21-.08.44-.1.68-.07.24.03.49.12.75.26s.53.35.8.63c.34.34.59.66.76.97s.27.6.3.87c.03.27,0,.52-.08.74s-.21.42-.38.59h-.02ZM203.6,92.54c.11-.11.2-.27.25-.46.05-.2.06-.43,0-.7-.36-.3-.69-.48-.98-.52-.3-.04-.55.04-.77.26-.08.08-.14.18-.18.28-.04.11-.05.22-.04.34,0,.12.05.24.11.36s.15.24.26.35c.22.22.45.35.68.37.23.02.45-.07.66-.28h0Z"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M212.59,103.35c-.34.34-.76.46-1.26.35s-1.03-.45-1.6-1.02-.91-1.1-1.01-1.59c-.11-.49,0-.9.35-1.25.34-.34.75-.46,1.24-.35s1.02.44,1.59,1.01c.57.57.91,1.1,1.02,1.6.11.49,0,.91-.34,1.25h0ZM212.24,103c.1-.1.16-.22.19-.35.02-.13,0-.29-.05-.46-.06-.17-.16-.37-.31-.58s-.34-.44-.59-.69-.47-.44-.68-.59-.4-.24-.57-.3c-.17-.05-.32-.07-.46-.04-.13.03-.25.09-.35.19-.1.1-.16.22-.19.35s-.02.29.04.46c.05.17.15.36.3.57s.34.44.59.68c.5.5.92.79,1.26.9.35.1.62.05.82-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M215.1,102.52l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.09.08-.19.13-.3.14s-.22-.03-.32-.13c-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13.16.03.32.12.47.28.23.23.37.49.41.78.04.29,0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M216.55,99.39c-.16.16-.33.28-.51.37-.18.09-.36.14-.54.16s-.36,0-.53-.06-.32-.15-.46-.29c-.11-.11-.19-.23-.25-.36s-.09-.26-.11-.4-.02-.27,0-.4c.02-.13.04-.26.08-.39l-.02-.02c-.21.04-.43.04-.65,0-.22-.03-.42-.14-.6-.32-.13-.13-.22-.27-.28-.43s-.08-.31-.07-.48c0-.16.05-.32.12-.48s.18-.31.32-.45c.15-.15.3-.26.46-.33s.32-.11.49-.11c.16,0,.32.03.48.1.15.07.3.17.43.3.09.09.16.19.21.3s.09.22.12.34c.03.11.04.23.04.34s0,.21-.02.31l.02.02c.12-.03.24-.06.36-.07.13-.02.25-.02.38,0,.12.01.25.05.37.1.12.06.24.14.35.25.13.13.22.27.28.43s.08.33.06.51-.07.36-.15.54c-.09.18-.21.35-.38.51h0ZM214.88,97.24c0-.22,0-.41-.06-.59-.05-.18-.14-.32-.26-.45-.17-.17-.36-.26-.58-.27-.22-.01-.42.07-.61.26-.16.16-.24.34-.24.54s.08.39.24.55c.1.1.21.17.33.2s.24.04.37.02c.13-.02.26-.05.4-.1.14-.05.28-.11.42-.17h0ZM216.24,99.05c.2-.2.3-.41.32-.64,0-.23-.07-.44-.25-.61-.11-.11-.23-.18-.36-.21s-.26-.03-.4,0-.29.07-.46.13c-.16.06-.32.13-.49.2-.04.23-.05.45-.02.66.03.21.12.4.28.55.1.1.2.16.31.2.12.04.23.06.36.05.12,0,.24-.04.37-.1.12-.06.23-.14.33-.24h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M219.1,96.83c-.13.13-.27.24-.41.33-.14.08-.27.15-.4.2-.13.05-.26.08-.39.1s-.25.02-.37.02l-.08-.5c.2,0,.41-.02.62-.08.21-.06.42-.19.62-.38.1-.1.18-.22.23-.34.05-.13.08-.26.08-.39s-.03-.27-.09-.4c-.05-.13-.14-.26-.26-.38-.23-.23-.48-.35-.74-.35s-.5.11-.72.33c-.12.12-.2.23-.25.35-.05.12-.09.26-.12.43l-.38.08-1.52-1.74,1.69-1.69.38.38-1.31,1.31.91,1.09c.04-.12.09-.24.14-.35s.13-.21.24-.31c.14-.15.3-.26.47-.35.17-.08.35-.13.53-.14.18,0,.37.03.55.1.19.08.37.21.55.39.19.18.32.38.39.58.08.21.11.41.1.61,0,.2-.05.4-.14.59-.09.19-.2.36-.35.5h.03Z"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M226.39,103.68c-.34.34-.76.46-1.26.35s-1.03-.45-1.6-1.02-.91-1.1-1.01-1.59c-.11-.49,0-.9.35-1.25.34-.34.75-.46,1.24-.35s1.02.44,1.59,1.01c.57.57.91,1.1,1.02,1.6.11.49,0,.91-.34,1.25h0ZM226.04,103.33c.1-.1.16-.22.19-.35.02-.13,0-.29-.05-.46-.06-.17-.16-.37-.31-.58s-.34-.44-.59-.69-.47-.44-.68-.59-.4-.24-.57-.3c-.17-.05-.32-.07-.46-.04-.13.03-.25.09-.35.19-.1.1-.16.22-.19.35s-.02.29.04.46c.05.17.15.36.3.57s.34.44.59.68c.5.5.92.79,1.26.9.35.1.62.05.82-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M228.89,102.84l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.09.08-.19.13-.3.14s-.22-.03-.32-.13c-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13.16.03.32.12.47.28.23.23.37.49.41.78.04.29,0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M230.35,99.71c-.16.16-.33.28-.51.37-.18.09-.36.14-.54.16s-.36,0-.53-.06-.32-.15-.46-.29c-.11-.11-.19-.23-.25-.36s-.09-.26-.11-.4-.02-.27,0-.4c.02-.13.04-.26.08-.39l-.02-.02c-.21.04-.43.04-.65,0-.22-.03-.42-.14-.6-.32-.13-.13-.22-.27-.28-.43s-.08-.31-.07-.48c0-.16.05-.32.12-.48s.18-.31.32-.45c.15-.15.3-.26.46-.33s.32-.11.49-.11c.16,0,.32.03.48.1.15.07.3.17.43.3.09.09.16.19.21.3s.09.22.12.34c.03.11.04.23.04.34s0,.21-.02.31l.02.02c.12-.03.24-.06.36-.07.13-.02.25-.02.38,0,.12.01.25.05.37.1.12.06.24.14.35.25.13.13.22.27.28.43s.08.33.06.51-.07.36-.15.54c-.09.18-.21.35-.38.51h0ZM228.68,97.57c0-.22,0-.41-.06-.59-.05-.18-.14-.32-.26-.45-.17-.17-.36-.26-.58-.27-.22-.01-.42.07-.61.26-.16.16-.24.34-.24.54s.08.39.24.55c.1.1.21.17.33.2s.24.04.37.02c.13-.02.26-.05.4-.1.14-.05.28-.11.42-.17h0ZM230.04,99.38c.2-.2.3-.41.32-.64,0-.23-.07-.44-.25-.61-.11-.11-.23-.18-.36-.21s-.26-.03-.4,0-.29.07-.46.13c-.16.06-.32.13-.49.2-.04.23-.05.45-.02.66.03.21.12.4.28.55.1.1.2.16.31.2.12.04.23.06.36.05.12,0,.24-.04.37-.1.12-.06.23-.14.33-.24h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M233.21,96.73l-.93-.93-1.52,1.52-.29-.29-.72-3.61.49-.49,2.1,2.1.46-.46.35.35-.46.46.93.93-.41.41h0ZM230.86,96.51l1.06-1.06-.98-.98c-.09-.09-.2-.2-.32-.33-.12-.13-.22-.25-.31-.34l-.02.02c.04.12.07.25.11.37.03.12.06.25.09.38l.37,1.95h0Z"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M240.18,106.26c-.34.34-.76.46-1.26.35s-1.03-.45-1.6-1.02-.91-1.1-1.01-1.59,0-.9.35-1.25c.34-.34.75-.46,1.24-.35s1.02.44,1.58,1.01c.57.57.91,1.1,1.02,1.6.11.49,0,.91-.34,1.25h.02ZM239.83,105.91c.1-.1.16-.22.19-.35s0-.29-.05-.46c-.06-.17-.16-.37-.31-.58s-.34-.44-.59-.69-.47-.44-.68-.59-.4-.24-.57-.3c-.17-.05-.32-.07-.45-.04-.13.03-.25.09-.35.19-.1.1-.16.22-.19.35s-.02.29.04.46c.05.17.15.36.3.57.14.21.34.44.59.68.5.5.92.79,1.26.9.35.1.62.05.82-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M242.69,105.43l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.08.08-.18.13-.3.14-.11.01-.22-.03-.32-.13-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13s.32.12.47.28c.23.23.37.49.41.78.04.29,0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M243.69,102.62c-.3-.33-.57-.65-.79-.96-.22-.31-.42-.62-.58-.93s-.3-.64-.4-.98c-.1-.34-.19-.71-.26-1.11l-1.69,1.69-.38-.38,2.18-2.18.27.27c.05.46.13.86.24,1.22s.25.7.41,1.01c.17.32.37.63.61.93s.51.63.83.97l-.45.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M246.54,99.9c-.18.18-.37.3-.57.37s-.4.1-.6.09l-.03-.52c.15.01.3,0,.45-.06.15-.05.27-.12.38-.23.12-.12.21-.26.26-.41.06-.15.07-.33.04-.53-.03-.2-.12-.41-.25-.64s-.34-.49-.6-.76c.03.24,0,.47-.05.69-.06.22-.17.4-.31.54-.29.29-.61.44-.96.44s-.69-.18-1.04-.53c-.16-.16-.28-.34-.36-.52-.08-.19-.12-.37-.13-.56,0-.19.03-.37.09-.54s.17-.33.3-.46c.17-.17.36-.29.57-.36.21-.08.44-.1.68-.07.24.03.49.12.75.26s.53.35.8.63c.34.34.59.66.76.97s.27.6.3.87c.03.27,0,.52-.08.74s-.21.42-.38.59h-.02ZM244.99,98.04c.11-.11.2-.27.25-.46.05-.2.06-.43,0-.7-.36-.3-.69-.48-.99-.52s-.55.04-.77.26c-.08.08-.14.18-.18.28-.04.11-.05.22-.04.34,0,.12.05.24.11.36s.15.24.26.35c.22.22.45.35.68.37.23.02.45-.07.66-.28h.02Z"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M253.98,108.85c-.34.34-.76.46-1.26.35s-1.03-.45-1.6-1.02-.91-1.1-1.01-1.59,0-.9.35-1.25c.34-.34.75-.46,1.24-.35s1.02.44,1.58,1.01c.57.57.91,1.1,1.02,1.6.11.49,0,.91-.34,1.25h.02ZM253.63,108.5c.1-.1.16-.22.19-.35s0-.29-.05-.46c-.06-.17-.16-.37-.31-.58s-.34-.44-.59-.69-.47-.44-.68-.59-.4-.24-.57-.3c-.17-.05-.32-.07-.45-.04-.13.03-.25.09-.35.19-.1.1-.16.22-.19.35s-.02.29.04.46c.05.17.15.36.3.57.14.21.34.44.59.68.5.5.92.79,1.26.9.35.1.62.05.82-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M256.49,108.01l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.08.08-.18.13-.3.14-.11.01-.22-.03-.32-.13-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13s.32.12.47.28c.23.23.37.49.41.78s0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M257.49,105.21c-.3-.33-.57-.65-.79-.96s-.42-.62-.58-.93c-.16-.31-.3-.64-.4-.98-.1-.34-.19-.71-.26-1.11l-1.69,1.69-.38-.38,2.18-2.18.27.27c.05.46.13.86.24,1.22s.25.7.41,1.01c.17.32.37.63.61.93s.51.63.83.97l-.45.45h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M260.8,101.9l-.93-.93-1.52,1.52-.29-.29-.72-3.61.49-.49,2.1,2.1.46-.46.35.35-.46.46.93.93-.41.41h0ZM258.46,101.68l1.06-1.06-.98-.98c-.09-.09-.2-.2-.32-.33-.12-.13-.22-.25-.31-.34l-.02.02c.04.12.07.25.11.37.03.12.06.25.09.38l.37,1.95h0Z"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M267.78,116.34c-.34.34-.76.46-1.26.35s-1.03-.45-1.6-1.02-.91-1.1-1.01-1.59.01-.9.35-1.25c.34-.34.75-.46,1.24-.35s1.02.44,1.58,1.01c.57.57.91,1.1,1.02,1.6.11.49,0,.91-.34,1.25h.02ZM267.43,115.99c.1-.1.16-.22.19-.35s0-.29-.05-.46c-.06-.17-.16-.37-.31-.58s-.34-.44-.59-.69-.47-.44-.68-.59-.4-.24-.57-.3c-.17-.05-.32-.07-.45-.04s-.25.09-.35.19c-.1.1-.16.22-.19.35s-.02.29.04.46c.05.17.15.36.3.57.14.21.34.44.59.68.5.5.92.79,1.26.9.35.1.62.05.82-.14h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M270.29,115.51l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.08.08-.18.13-.3.14-.11.01-.22-.03-.32-.13-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13s.32.12.47.28c.23.23.37.49.41.78s0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M271.65,112.47c-.13.13-.27.24-.41.33-.14.08-.27.15-.41.2-.13.05-.26.08-.39.1s-.25.02-.37.02l-.07-.5c.2,0,.41-.02.62-.08.21-.06.42-.19.62-.38.1-.1.18-.22.23-.34.05-.13.08-.26.08-.39s-.03-.27-.08-.4c-.06-.13-.14-.26-.26-.38-.23-.23-.48-.35-.74-.35s-.5.11-.72.33c-.12.12-.2.23-.25.35-.05.12-.09.26-.12.43l-.38.08-1.52-1.74,1.69-1.69.38.38-1.31,1.31.91,1.09c.04-.12.09-.24.14-.35.06-.11.14-.21.24-.31.14-.15.3-.26.47-.35.17-.08.34-.13.53-.14.18,0,.37.03.55.1.19.08.37.21.56.39.18.18.31.38.39.58.08.21.11.41.1.61,0,.2-.06.4-.14.59-.09.19-.2.36-.35.5h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M274.13,109.99c-.18.18-.37.3-.57.37s-.4.1-.6.09l-.03-.52c.15.01.3,0,.45-.06.15-.05.27-.12.38-.23.12-.12.21-.26.26-.41.06-.15.07-.33.04-.53s-.12-.41-.25-.64-.34-.49-.6-.76c.03.24,0,.47-.05.69-.06.22-.17.4-.31.54-.29.29-.61.44-.96.44s-.69-.18-1.04-.53c-.16-.16-.28-.34-.36-.52-.08-.19-.12-.37-.13-.56,0-.19.03-.37.09-.54s.17-.33.3-.46c.17-.17.36-.29.57-.36.21-.08.44-.1.68-.07s.49.12.75.26.53.35.8.63c.34.34.59.66.76.97s.27.6.3.87c.03.27,0,.52-.08.74s-.21.42-.38.59h-.02ZM272.59,108.12c.11-.11.2-.27.25-.46.05-.2.06-.43,0-.7-.36-.3-.69-.48-.99-.52s-.55.04-.77.26c-.08.08-.14.18-.18.28-.04.11-.05.22-.04.34.01.12.05.24.11.36s.15.24.26.35c.22.22.45.35.68.37.23.02.45-.07.66-.28h.02Z"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M281.57,121.26c-.34.34-.76.46-1.26.35-.49-.11-1.03-.45-1.6-1.02s-.91-1.1-1.01-1.59c-.11-.49.01-.9.36-1.25.34-.34.75-.46,1.24-.35s1.02.44,1.58,1.01c.57.57.91,1.1,1.03,1.6.11.49,0,.91-.34,1.25h0ZM281.22,120.91c.1-.1.16-.22.19-.35s0-.29-.05-.46c-.06-.17-.16-.37-.3-.58-.15-.21-.34-.44-.59-.69s-.47-.44-.68-.59-.4-.24-.57-.3c-.17-.05-.32-.07-.45-.04s-.25.09-.35.19c-.1.1-.16.22-.19.35s-.02.29.04.46c.05.17.15.36.3.57.14.21.34.44.59.68.5.5.92.79,1.26.9.35.1.62.05.81-.14h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M284.08,120.42l-.36-.15c.09-.22.12-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.08.08-.18.13-.3.14-.11.01-.22-.03-.32-.13s-.14-.2-.13-.32c0-.12.06-.22.14-.31.11-.11.25-.16.41-.13.16.03.32.12.47.28.23.23.37.49.41.78s0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M285.45,117.38c-.13.13-.27.24-.41.33-.14.08-.28.15-.41.2-.13.05-.26.08-.39.1s-.25.02-.37.02l-.07-.5c.2,0,.41-.02.62-.08.21-.06.42-.19.62-.38.1-.1.18-.22.23-.34.05-.13.08-.26.08-.39s-.03-.27-.08-.4c-.06-.13-.14-.26-.26-.38-.23-.23-.48-.35-.74-.35s-.5.11-.72.33c-.12.12-.2.23-.25.35-.05.12-.09.26-.12.43l-.38.08-1.52-1.74,1.69-1.69.38.38-1.31,1.31.91,1.09c.04-.12.09-.24.14-.35.06-.11.13-.21.24-.31.14-.15.3-.26.47-.35.17-.08.34-.13.53-.14.18,0,.37.03.55.1.19.08.37.21.56.39.18.18.31.38.39.58.08.21.11.41.1.61,0,.2-.06.4-.14.59-.09.19-.2.36-.35.5h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M288.17,114.66c-.34.34-.76.46-1.26.35-.49-.11-1.03-.46-1.6-1.02-.57-.57-.91-1.1-1.01-1.59-.11-.49.01-.9.36-1.25.34-.34.75-.46,1.24-.35s1.02.44,1.59,1.01.91,1.1,1.02,1.6c.11.49,0,.91-.34,1.25h0ZM287.81,114.31c.1-.1.16-.22.19-.35s0-.29-.05-.46c-.06-.17-.16-.37-.3-.58-.15-.21-.34-.44-.59-.69s-.47-.44-.68-.59-.4-.24-.57-.3c-.17-.05-.32-.07-.45-.04s-.25.09-.35.19c-.1.1-.16.22-.19.35s-.02.29.04.46c.05.17.15.36.3.57.14.21.34.44.59.68.5.5.92.79,1.26.9.35.1.62.05.81-.14h-.01Z"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M295.37,123.84c-.34.34-.76.46-1.26.35s-1.03-.45-1.6-1.02-.91-1.1-1.01-1.59.01-.9.35-1.25c.34-.34.75-.46,1.24-.35s1.02.44,1.58,1.01c.57.57.91,1.1,1.02,1.6.11.49,0,.91-.34,1.25h.02ZM295.02,123.49c.1-.1.16-.22.19-.35s0-.29-.05-.46c-.06-.17-.16-.37-.31-.58s-.34-.44-.59-.69-.47-.44-.68-.59-.4-.24-.57-.3c-.17-.05-.32-.07-.45-.04s-.25.09-.35.19c-.1.1-.16.22-.19.35s-.02.29.04.46c.05.17.15.36.3.57.14.21.34.44.59.68.5.5.92.79,1.26.9.35.1.62.05.82-.14h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M297.88,123.01l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.08.08-.18.13-.3.14-.11.01-.22-.03-.32-.13-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13s.32.12.47.28c.23.23.37.49.41.78s0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M299.55,119.53l-.93-.93-1.52,1.52-.29-.29-.72-3.61.49-.49,2.1,2.1.46-.46.35.35-.46.46.93.93-.41.41h0ZM297.21,119.31l1.06-1.06-.98-.98c-.09-.09-.2-.2-.32-.33-.12-.13-.22-.25-.31-.34l-.02.02c.04.12.07.25.11.37.03.12.06.25.09.38l.37,1.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M301.88,117.33c-.13.13-.27.24-.41.33-.14.08-.27.15-.41.2-.13.05-.26.08-.39.1s-.25.02-.37.02l-.08-.5c.2,0,.41-.02.62-.08.21-.06.42-.19.62-.38.1-.1.18-.22.23-.34.05-.13.08-.26.08-.39s-.03-.27-.09-.4c-.06-.13-.14-.26-.26-.38-.23-.23-.48-.35-.74-.35s-.5.11-.72.33c-.12.12-.2.23-.25.35-.05.12-.09.26-.12.43l-.38.08-1.52-1.74,1.69-1.69.38.38-1.31,1.31.91,1.09c.04-.12.09-.24.14-.35.06-.11.14-.21.24-.31.15-.15.3-.26.47-.35.17-.08.35-.13.53-.14.18,0,.37.03.55.1.19.08.37.21.56.39s.32.38.39.58c.08.21.11.41.1.61,0,.2-.05.4-.14.59-.08.19-.2.36-.35.5h.03Z"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M309.17,124.88c-.34.34-.76.46-1.26.35-.49-.11-1.03-.45-1.6-1.02s-.91-1.1-1.01-1.59c-.11-.49.01-.9.36-1.25.34-.34.75-.46,1.24-.35s1.02.44,1.58,1.01c.57.57.91,1.1,1.03,1.6.11.49,0,.91-.34,1.25h0ZM308.82,124.53c.1-.1.16-.22.19-.35s0-.29-.05-.46c-.06-.17-.16-.37-.3-.58-.15-.21-.34-.44-.59-.69s-.47-.44-.68-.59-.4-.24-.57-.3c-.17-.05-.32-.07-.45-.04s-.25.09-.35.19c-.1.1-.16.22-.19.35s-.02.29.04.46c.05.17.15.36.3.57.14.21.34.44.59.68.5.5.92.79,1.26.9.35.1.62.05.81-.14h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M311.68,124.04l-.36-.15c.09-.22.12-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.08.08-.18.13-.3.14-.11.01-.22-.03-.32-.13s-.14-.2-.13-.32c0-.12.06-.22.14-.31.11-.11.25-.16.41-.13.16.03.32.12.47.28.23.23.37.49.41.78s0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M313.35,120.56l-.93-.93-1.52,1.52-.29-.29-.71-3.61.49-.49,2.1,2.1.46-.46.35.35-.46.46.93.93-.41.41h-.01ZM311.01,120.34l1.06-1.06-.98-.98c-.09-.09-.2-.2-.32-.33-.12-.13-.22-.25-.31-.34l-.02.02c.04.12.07.25.11.37.03.12.06.25.09.38l.37,1.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M315.69,118.35c-.13.13-.27.24-.41.33-.14.08-.28.15-.41.2-.14.05-.27.08-.4.1s-.25.02-.37.01l-.06-.51c.21,0,.42-.02.64-.08.22-.05.43-.18.63-.38.21-.21.32-.43.34-.67s-.07-.46-.26-.65c-.1-.1-.21-.17-.33-.22s-.25-.06-.4-.03c-.14.02-.3.09-.47.2s-.36.26-.56.46l-.33-.33c.18-.18.32-.35.41-.5s.14-.3.16-.43,0-.25-.04-.36-.11-.21-.2-.3c-.17-.17-.35-.24-.55-.24s-.39.1-.57.28c-.14.14-.24.3-.29.49-.05.18-.08.38-.08.58l-.51-.04c0-.25.05-.5.13-.74.08-.24.22-.46.42-.66.15-.15.3-.27.47-.35.16-.08.32-.14.49-.15.16-.02.32,0,.48.06s.3.15.44.29c.21.21.32.43.33.67.02.24-.03.49-.14.75l.02.02c.13-.08.26-.14.39-.18.14-.04.28-.06.41-.05.14,0,.28.04.41.1s.26.14.37.26c.15.15.25.31.32.49.06.18.08.36.07.54s-.07.36-.16.54-.21.35-.37.5h-.02Z"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M322.96,127.46c-.34.34-.76.46-1.26.35-.49-.11-1.03-.45-1.6-1.02s-.91-1.1-1.01-1.59c-.11-.49.01-.9.36-1.25.34-.34.75-.46,1.24-.35s1.02.44,1.58,1.01c.57.57.91,1.1,1.03,1.6.11.49,0,.91-.34,1.25h0ZM322.61,127.11c.1-.1.16-.22.19-.35s0-.29-.05-.46c-.06-.17-.16-.37-.3-.58-.15-.21-.34-.44-.59-.69s-.47-.44-.68-.59-.4-.24-.57-.3c-.17-.05-.32-.07-.45-.04s-.25.09-.35.19c-.1.1-.16.22-.19.35s-.02.29.04.46c.05.17.15.36.3.57.14.21.34.44.59.68.5.5.92.79,1.26.9.35.1.62.05.81-.14h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M325.47,126.63l-.36-.15c.09-.22.12-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.08.08-.18.13-.3.14-.11.01-.22-.03-.32-.13s-.14-.2-.13-.32c0-.12.06-.22.14-.31.11-.11.25-.16.41-.13.16.03.32.12.47.28.23.23.37.49.41.78s0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M326.85,123.57c-.13.13-.27.24-.41.33-.14.08-.28.15-.41.2-.13.05-.27.08-.4.1s-.25.02-.38.01l-.06-.51c.21,0,.42-.02.64-.08.22-.05.43-.18.63-.38.21-.21.32-.43.34-.67s-.07-.46-.26-.65c-.1-.1-.21-.17-.33-.22s-.25-.06-.4-.03c-.14.02-.3.09-.47.2s-.36.26-.56.46l-.34-.33c.18-.18.32-.35.41-.5s.14-.3.16-.43,0-.25-.04-.36-.11-.21-.2-.3c-.17-.17-.35-.24-.55-.24s-.39.1-.57.28c-.14.14-.24.3-.29.49-.05.18-.08.38-.08.58l-.51-.04c0-.25.05-.5.13-.74.08-.24.22-.46.42-.66.15-.15.3-.27.47-.35.16-.08.33-.14.49-.15.16-.02.32,0,.48.06s.3.15.44.29c.21.21.32.43.33.67.02.24-.03.49-.14.75l.02.02c.13-.08.26-.14.4-.18.13-.04.27-.06.41-.05.14,0,.28.04.41.1s.26.14.37.26c.15.15.25.31.31.49s.08.36.07.54c-.02.18-.07.36-.16.54s-.21.35-.37.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M329.56,120.86c-.16.16-.33.28-.51.37-.18.09-.36.14-.54.16s-.36,0-.53-.06-.32-.15-.46-.29c-.11-.11-.19-.23-.25-.36s-.09-.26-.11-.4-.02-.27,0-.4c.02-.13.05-.26.08-.39l-.02-.02c-.21.04-.43.04-.65,0-.22-.03-.42-.14-.6-.32-.13-.13-.22-.27-.28-.43s-.08-.31-.07-.48c0-.16.05-.32.12-.48s.18-.31.32-.45c.15-.15.3-.26.46-.33s.32-.11.48-.11.32.03.48.1c.15.07.3.17.43.3.09.09.16.19.21.3s.09.22.12.34c.03.11.04.23.04.34s0,.21-.02.31l.02.02c.12-.03.24-.06.36-.07.13-.02.25-.02.38,0,.12.01.25.05.37.1.12.06.24.14.35.25.13.13.22.27.28.43s.08.33.06.51c-.01.18-.06.36-.15.54s-.21.35-.38.51h.01ZM327.89,118.72c.01-.22,0-.41-.06-.59-.05-.17-.14-.32-.26-.45-.17-.17-.36-.26-.58-.27-.22-.01-.42.07-.61.26-.16.16-.24.34-.24.54s.08.39.24.55c.1.1.21.17.33.2.11.03.24.04.37.02.13-.02.26-.05.4-.1.14-.05.28-.11.42-.17h-.01ZM329.25,120.53c.2-.2.3-.41.32-.64.01-.23-.07-.44-.25-.61-.11-.11-.23-.18-.36-.21-.12-.03-.26-.03-.4,0-.14.03-.29.07-.45.13s-.32.13-.49.2c-.04.23-.05.45-.02.66.03.21.12.4.28.55.1.1.2.16.32.2.11.04.23.06.36.05.12,0,.24-.04.37-.1.12-.06.23-.14.33-.24h-.01Z"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M336.76,130.05c-.34.34-.76.46-1.26.35s-1.03-.45-1.6-1.02-.91-1.1-1.01-1.59.01-.9.35-1.25c.34-.34.75-.46,1.24-.35s1.02.44,1.58,1.01c.57.57.91,1.1,1.02,1.6.11.49,0,.91-.34,1.25h.02ZM336.41,129.7c.1-.1.16-.22.19-.35s0-.29-.05-.46c-.06-.17-.16-.37-.31-.58s-.34-.44-.59-.69-.47-.44-.68-.59-.4-.24-.57-.3c-.17-.05-.32-.07-.45-.04s-.25.09-.35.19c-.1.1-.16.22-.19.35s-.02.29.04.46c.05.17.15.36.3.57.14.21.34.44.59.68.5.5.92.79,1.26.9.35.1.62.05.82-.14h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M339.27,129.21l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,.01-.02.03-.05.06-.08.08-.18.13-.3.14-.11,0-.22-.03-.32-.13-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13s.32.12.47.28c.23.23.37.49.41.78s0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M340.65,126.16c-.13.13-.27.24-.41.33-.14.08-.28.15-.41.2-.14.05-.27.08-.4.1s-.25.02-.37.01l-.06-.51c.21,0,.42-.02.64-.08.22-.05.43-.18.63-.38.21-.21.32-.43.34-.67s-.07-.46-.26-.65c-.1-.1-.21-.17-.33-.22s-.25-.06-.4-.03c-.14.02-.3.09-.47.2s-.36.26-.56.46l-.33-.33c.18-.18.32-.35.41-.5s.14-.3.16-.43,0-.25-.04-.36-.11-.21-.2-.3c-.17-.17-.35-.24-.55-.24s-.39.1-.57.28c-.14.14-.24.3-.29.49-.05.18-.08.38-.08.58l-.51-.04c0-.25.05-.5.13-.74.08-.24.22-.46.42-.66.15-.15.3-.27.47-.35.16-.08.33-.14.49-.15.16-.02.32,0,.48.06s.3.15.44.29c.21.21.32.43.33.67.02.24-.03.49-.14.75l.02.02c.13-.08.26-.14.4-.18.14-.04.27-.06.41-.05.14,0,.28.04.41.1s.26.14.37.26c.15.15.25.31.32.49.06.18.08.36.07.54-.02.18-.07.36-.16.54s-.21.35-.37.5h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M343.28,123.52c-.13.13-.27.24-.41.33-.14.08-.28.15-.41.2-.14.05-.27.08-.4.1s-.25.02-.37.01l-.06-.51c.21,0,.42-.02.64-.08.22-.05.43-.18.63-.38.21-.21.32-.43.34-.67s-.07-.46-.26-.65c-.1-.1-.21-.17-.33-.22s-.25-.06-.4-.03c-.14.02-.3.09-.47.2s-.35.26-.56.46l-.33-.33c.18-.18.32-.35.41-.5s.14-.3.16-.43,0-.25-.04-.36-.11-.21-.2-.3c-.17-.17-.35-.24-.55-.24s-.39.1-.57.28c-.14.14-.24.3-.29.49-.05.18-.08.38-.08.58l-.51-.04c0-.25.05-.5.13-.74.08-.24.22-.46.42-.66.15-.15.3-.27.47-.35.16-.08.33-.14.49-.15.16-.02.32,0,.48.06s.3.15.44.29c.21.21.32.43.33.67.02.24-.03.49-.14.75l.02.02c.13-.08.26-.14.39-.18.14-.04.28-.06.41-.05.14,0,.28.04.41.1s.26.14.37.26c.15.15.25.31.32.49.06.18.08.36.07.54s-.07.36-.16.54-.21.35-.37.5h-.02Z"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M350.56,132.12c-.34.34-.76.46-1.26.35s-1.03-.45-1.6-1.02-.91-1.1-1.01-1.59.01-.9.35-1.25c.34-.34.75-.46,1.24-.35s1.02.44,1.58,1.01c.57.57.91,1.1,1.02,1.6.11.49,0,.91-.34,1.25h.02ZM350.21,131.77c.1-.1.16-.22.19-.35s0-.29-.05-.46c-.06-.17-.16-.37-.31-.58s-.34-.44-.59-.69-.47-.44-.68-.59-.4-.24-.57-.3c-.17-.05-.32-.07-.45-.04-.13.03-.25.09-.35.19s-.16.22-.19.35-.02.29.04.46c.05.17.15.36.3.57.14.21.34.44.59.68.5.5.92.79,1.26.9.35.1.62.05.82-.14h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M353.07,131.28l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,0-.02.03-.05.06-.08.08-.18.13-.3.14-.11,0-.22-.03-.32-.13-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13s.32.12.47.28c.23.23.37.49.41.78s0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M353.34,129.2l-.26-.26v-1.37c0-.4-.03-.76-.07-1.07s-.1-.57-.17-.79c-.08-.22-.18-.4-.32-.53-.19-.19-.41-.3-.64-.32s-.45.08-.67.3c-.14.14-.23.31-.27.51-.04.2-.05.41-.04.62h-.5c-.01-.3.01-.57.08-.82s.21-.49.43-.71c.32-.31.65-.47,1.02-.47s.69.15,1,.45c.16.16.28.35.38.58.09.23.16.49.21.79.05.29.08.62.1.97.02.35.03.74.04,1.15.08-.1.17-.2.26-.31s.18-.2.27-.29l.98-.98.38.38-2.19,2.19-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M356.92,125.76c-.18.18-.37.3-.57.37s-.4.1-.6.09l-.03-.52c.15.01.3,0,.45-.06.15-.05.27-.12.38-.23.12-.12.21-.26.26-.41.06-.15.07-.33.04-.53s-.12-.41-.25-.64-.34-.49-.6-.76c.03.24,0,.47-.05.69-.06.22-.17.4-.31.54-.29.29-.61.44-.96.44s-.69-.18-1.04-.53c-.16-.16-.28-.34-.36-.52-.08-.19-.12-.37-.13-.56,0-.19.03-.37.09-.54s.17-.33.3-.46c.17-.17.36-.29.57-.36.21-.08.44-.1.68-.07s.49.12.75.26.53.35.8.63c.34.34.59.66.76.97s.27.6.3.87c.03.27,0,.52-.08.74s-.21.42-.38.59h-.02ZM355.37,123.89c.11-.11.2-.27.25-.46.05-.2.06-.43,0-.7-.36-.3-.69-.48-.99-.52s-.55.04-.77.26c-.08.08-.14.18-.18.28-.04.11-.05.22-.04.34.01.12.05.24.11.36s.15.24.26.35c.22.22.45.35.68.37.23.02.45-.07.66-.28h.02Z"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M364.35,132.11c-.34.34-.76.46-1.26.35s-1.03-.45-1.6-1.02-.91-1.1-1.01-1.59.01-.9.35-1.25c.34-.34.75-.46,1.24-.35s1.02.44,1.58,1.01c.57.57.91,1.1,1.02,1.6.11.49,0,.91-.34,1.25h.02ZM364,131.76c.1-.1.16-.22.19-.35s0-.29-.05-.46c-.06-.17-.16-.37-.31-.58s-.34-.44-.59-.69-.47-.44-.68-.59-.4-.24-.57-.3c-.17-.05-.32-.07-.45-.04-.13.03-.25.09-.35.19s-.16.22-.19.35-.02.29.04.46c.05.17.15.36.3.57.14.21.34.44.59.68.5.5.92.79,1.26.9.35.1.62.05.82-.14h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M366.86,131.28l-.36-.15c.08-.22.11-.43.09-.62-.03-.2-.11-.36-.26-.5,0,0-.02.03-.05.06-.08.08-.18.13-.3.14-.11,0-.22-.03-.32-.13-.09-.1-.14-.2-.13-.32,0-.12.06-.22.14-.31.11-.11.25-.16.41-.13s.32.12.47.28c.23.23.37.49.41.78s0,.59-.12.9h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M367.14,129.2l-.26-.26v-1.37c0-.4-.03-.76-.07-1.07s-.1-.57-.17-.79c-.08-.22-.18-.4-.32-.53-.19-.19-.41-.3-.64-.32s-.45.08-.67.3c-.14.14-.23.31-.27.51-.04.2-.05.41-.04.62h-.5c-.01-.3.01-.57.08-.82s.21-.49.43-.71c.32-.31.65-.47,1.02-.47s.69.15,1,.45c.16.16.28.35.38.58.09.23.16.49.21.79.05.29.08.62.1.97.02.35.03.74.04,1.15.08-.1.17-.2.26-.31s.18-.2.27-.29l.98-.98.38.38-2.19,2.19-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M370.71,125.76c-.18.18-.37.3-.57.37s-.4.1-.6.09l-.03-.52c.15.01.3,0,.45-.06.15-.05.27-.12.38-.23.12-.12.21-.26.26-.41.06-.15.07-.33.04-.53s-.12-.41-.25-.64-.34-.49-.6-.76c.03.24,0,.47-.05.69-.06.22-.17.4-.31.54-.29.29-.61.44-.96.44s-.69-.18-1.04-.53c-.16-.16-.28-.34-.36-.52-.08-.19-.12-.37-.13-.56,0-.19.03-.37.09-.54s.17-.33.3-.46c.17-.17.36-.29.57-.36.21-.08.44-.1.68-.07s.49.12.75.26.53.35.8.63c.34.34.59.66.76.97s.27.6.3.87c.03.27,0,.52-.08.74s-.21.42-.38.59h-.02ZM369.16,123.89c.11-.11.2-.27.25-.46.05-.2.06-.43,0-.7-.36-.3-.69-.48-.99-.52s-.55.04-.77.26c-.08.08-.14.18-.18.28-.04.11-.05.22-.04.34.01.12.05.24.11.36s.15.24.26.35c.22.22.45.35.68.37.23.02.45-.07.66-.28h.02Z"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M2.62,161.45c-.39,0-.75-.07-1.09-.22-.33-.15-.62-.35-.87-.6l.43-.49c.2.21.43.38.7.51.27.13.55.19.84.19.37,0,.65-.08.86-.25.2-.17.31-.39.31-.66,0-.14-.02-.26-.07-.36s-.11-.18-.2-.26c-.08-.07-.18-.13-.29-.19s-.23-.12-.37-.18l-.8-.35c-.13-.06-.26-.12-.4-.2s-.26-.18-.37-.29-.2-.25-.26-.4-.1-.34-.1-.54.04-.4.13-.59c.09-.18.21-.34.37-.47s.34-.24.55-.31.45-.11.7-.11c.33,0,.64.06.93.19.28.13.52.29.72.5l-.38.46c-.17-.16-.36-.29-.57-.39-.21-.09-.44-.14-.7-.14-.31,0-.56.07-.75.22-.19.14-.29.34-.29.6,0,.14.03.25.08.34.05.09.13.18.22.25s.19.13.3.19c.11.05.22.1.33.15l.79.34c.16.07.31.15.45.23.14.09.26.19.37.31s.18.25.24.41.09.34.09.54c0,.22-.04.43-.13.62s-.21.36-.38.51c-.16.14-.36.26-.59.34-.23.08-.5.12-.79.12v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M5.61,161.35v-5.58h3.21v.6h-2.51v1.75h2.12v.6h-2.12v2.02h2.59v.6h-3.3.01Z"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M14.64,161.35v-5.58h1.66c.28,0,.54.03.78.08s.44.13.6.24c.17.11.3.25.39.42s.14.38.14.62c0,.28-.07.53-.21.75s-.34.38-.61.46v.03c.34.06.61.2.82.42s.31.52.31.91c0,.27-.05.51-.15.71s-.25.37-.43.51c-.19.14-.41.24-.67.31s-.55.1-.86.1h-1.78v.02ZM15.34,158.14h.82c.48,0,.82-.08,1.03-.25.21-.16.31-.39.31-.67,0-.32-.11-.55-.33-.69s-.55-.2-.98-.2h-.86v1.81h0ZM15.34,160.78h.97c.48,0,.86-.09,1.12-.27.27-.18.4-.46.4-.83,0-.35-.13-.6-.39-.76-.26-.16-.64-.24-1.13-.24h-.97s0,2.1,0,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M19.64,161.35v-5.58h3.21v.6h-2.51v1.75h2.12v.6h-2.12v2.02h2.59v.6h-3.3,0Z"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M28.08,161.35l1.89-5.58h.8l1.89,5.58h-.76l-.53-1.7h-2.03l-.54,1.7s-.72,0-.72,0ZM29.78,158.23l-.26.85h1.67l-.26-.85c-.1-.31-.2-.62-.29-.93s-.18-.62-.27-.95h-.03c-.08.32-.17.64-.26.95s-.19.62-.29.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M34.13,161.35v-4.98h-1.68v-.6h4.08v.6h-1.68v4.98h-.72Z"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M43.76,161.35v-5.58h3.21v.6h-2.51v1.89h2.12v.6h-2.12v2.5h-.71,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M47.96,161.35v-5.58h.71v5.58h-.71Z"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M55.92,161.35v-5.58h1.39c.86,0,1.52.24,1.96.71.45.48.67,1.16.67,2.05,0,.44-.06.84-.17,1.19-.11.35-.28.64-.5.88s-.49.42-.82.55c-.32.13-.69.19-1.11.19h-1.43.01ZM56.63,160.77h.64c.65,0,1.14-.2,1.47-.59s.49-.94.49-1.65-.16-1.25-.49-1.62-.81-.56-1.47-.56h-.64v4.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M61.15,161.35v-5.58h3.21v.6h-2.51v1.75h2.12v.6h-2.12v2.02h2.59v.6h-3.3,0Z"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M69.5,161.35v-5.58h1.39c.86,0,1.52.24,1.96.71.45.48.67,1.16.67,2.05,0,.44-.06.84-.17,1.19s-.28.64-.5.88-.49.42-.82.55c-.32.13-.69.19-1.11.19h-1.43.01ZM70.21,160.77h.64c.65,0,1.14-.2,1.47-.59s.49-.94.49-1.65-.16-1.25-.49-1.62-.81-.56-1.47-.56h-.64v4.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M74.73,161.35v-5.58h.71v2.8h.03l2.32-2.8h.8l-1.74,2.12,2.01,3.45h-.79l-1.67-2.9-.96,1.13v1.77h-.71Z"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M83.56,161.35v-5.58h.73l2.01,3.5.6,1.16h.03c-.02-.28-.04-.58-.06-.88s-.03-.6-.03-.9v-2.88h.67v5.58h-.73l-2.02-3.51-.6-1.15h-.03c.02.28.04.57.06.86s.03.59.03.88v2.92h-.67,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M89.06,161.35v-5.58h.71v4.97h2.44v.6h-3.15Z"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M100.33,161.45c-.39,0-.75-.07-1.09-.22-.33-.15-.62-.35-.87-.6l.43-.49c.2.21.43.38.7.51.27.13.55.19.84.19.37,0,.65-.08.86-.25.2-.17.31-.39.31-.66,0-.14-.02-.26-.07-.36s-.11-.18-.2-.26c-.08-.07-.18-.13-.29-.19s-.23-.12-.37-.18l-.8-.35c-.13-.06-.26-.12-.4-.2s-.26-.18-.37-.29-.2-.25-.26-.4-.1-.34-.1-.54.04-.4.13-.59c.09-.18.21-.34.37-.47s.34-.24.55-.31.45-.11.7-.11c.33,0,.64.06.93.19.28.13.52.29.72.5l-.38.46c-.17-.16-.36-.29-.57-.39-.21-.09-.44-.14-.7-.14-.31,0-.56.07-.75.22-.19.14-.29.34-.29.6,0,.14.03.25.08.34s.13.18.22.25c.09.07.19.13.3.19.11.05.22.1.33.15l.79.34c.16.07.31.15.45.23.14.09.26.19.37.31s.18.25.24.41.09.34.09.54c0,.22-.04.43-.13.62s-.21.36-.38.51c-.16.14-.36.26-.59.34-.23.08-.5.12-.79.12v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M103.32,161.35v-5.58h.71v5.58h-.71Z"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M111.45,161.35v-5.58h3.21v.6h-2.51v1.89h2.12v.6h-2.12v2.5h-.71.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M115.65,161.35v-5.58h1.74c.28,0,.54.03.79.08s.45.14.62.27.31.29.4.48c.1.2.14.44.14.73,0,.44-.11.79-.34,1.05s-.53.44-.92.54l1.42,2.43h-.8l-1.34-2.35h-1.01v2.35h-.71,0ZM116.36,158.41h.93c.44,0,.77-.09,1-.27.23-.18.35-.45.35-.81s-.12-.63-.35-.77c-.23-.15-.57-.22-1-.22h-.93v2.07Z"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M125.29,161.35v-5.58h3.21v.6h-2.51v1.75h2.12v.6h-2.12v2.02h2.59v.6h-3.3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M129.77,161.35v-5.58h3.21v.6h-2.51v1.75h2.12v.6h-2.12v2.02h2.59v.6h-3.3,0Z"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M141,161.45c-.35,0-.67-.07-.97-.2-.29-.13-.55-.32-.77-.57s-.39-.55-.51-.91-.18-.77-.18-1.22.06-.85.19-1.21c.12-.36.3-.66.52-.91s.48-.44.78-.57.63-.2.99-.2.64.07.9.21.47.3.63.48l-.38.46c-.15-.16-.31-.29-.5-.38-.19-.1-.4-.14-.64-.14-.27,0-.51.05-.72.16-.22.1-.4.26-.55.45-.15.2-.27.43-.35.71-.08.28-.12.59-.12.94s.04.67.12.95.2.52.34.72c.15.2.33.35.54.46.21.11.45.16.72.16s.51-.06.71-.17c.2-.11.4-.27.58-.46l.39.44c-.22.25-.47.45-.75.6-.28.14-.6.21-.96.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M143.28,161.35v-.42l2.93-4.56h-2.67v-.6h3.55v.42l-2.94,4.56h2.97v.6h-3.84Z"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M154.01,161.35v-5.58h.71v5.58h-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M156.25,161.35v-5.58h3.21v.6h-2.51v1.75h2.12v.6h-2.12v2.02h2.59v.6h-3.3,0Z"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M166.59,161.35v-5.58h1.59c.31,0,.6.03.85.08.26.06.48.15.66.28.18.13.32.3.42.51.1.21.15.47.15.77s-.05.55-.15.77c-.1.22-.24.39-.42.54s-.4.25-.65.32-.53.11-.84.11h-.92v2.21h-.71.02ZM167.29,158.56h.83c.49,0,.85-.09,1.08-.28.24-.18.35-.47.35-.87s-.12-.68-.37-.84-.61-.23-1.1-.23h-.8v2.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M172.35,161.35v-4.98h-1.68v-.6h4.08v.6h-1.68v4.98h-.72Z"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M179.46,161.35v-5.58h.71v2.34h2.59v-2.34h.71v5.58h-.71v-2.63h-2.59v2.63h-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M186.98,161.45c-.28,0-.55-.04-.79-.12-.25-.08-.46-.22-.64-.41s-.32-.44-.42-.74c-.1-.31-.15-.68-.15-1.13v-3.27h.71v3.29c0,.33.03.62.1.84.07.23.16.41.28.54.12.14.25.23.41.29s.33.09.51.09.36-.03.52-.09.3-.16.42-.29c.12-.14.21-.32.28-.54.07-.23.1-.51.1-.84v-3.29h.68v3.27c0,.45-.05.82-.15,1.13-.1.31-.24.55-.42.74s-.39.33-.63.41-.51.12-.79.12h-.02Z"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M194.3,161.35v-5.58h1.59c.31,0,.6.03.85.08.26.06.48.15.66.28.18.13.32.3.42.51.1.21.15.47.15.77s-.05.55-.15.77c-.1.22-.24.39-.42.54s-.4.25-.65.32-.53.11-.84.11h-.92v2.21h-.71.02ZM195,158.56h.83c.49,0,.85-.09,1.08-.28.24-.18.35-.47.35-.87s-.12-.68-.37-.84-.61-.23-1.1-.23h-.8v2.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M199.11,161.35v-5.58h.71v4.97h2.44v.6h-3.15Z"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M208.26,161.35v-5.58h3.21v.6h-2.51v1.75h2.12v.6h-2.12v2.02h2.59v.6h-3.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M212.74,161.35v-5.58h.71v4.97h2.44v.6h-3.15Z"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M221.86,161.35v-5.58h3.21v.6h-2.51v1.75h2.12v.6h-2.12v2.02h2.59v.6h-3.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M227.88,161.45c-.39,0-.75-.07-1.09-.22-.33-.15-.62-.35-.87-.6l.43-.49c.2.21.43.38.7.51.27.13.55.19.84.19.37,0,.65-.08.86-.25.2-.17.31-.39.31-.66,0-.14-.02-.26-.07-.36s-.11-.18-.2-.26c-.08-.07-.18-.13-.29-.19s-.24-.12-.37-.18l-.8-.35c-.13-.06-.26-.12-.4-.2s-.26-.18-.37-.29-.2-.25-.26-.4c-.07-.16-.1-.34-.1-.54s.04-.4.13-.59c.09-.18.21-.34.37-.47.16-.13.34-.24.55-.31.21-.07.45-.11.7-.11.33,0,.64.06.93.19.28.13.52.29.72.5l-.38.46c-.17-.16-.36-.29-.57-.39-.21-.09-.44-.14-.7-.14-.31,0-.56.07-.75.22-.19.14-.29.34-.29.6,0,.14.03.25.08.34s.13.18.22.25.19.13.3.19c.11.05.22.1.33.15l.79.34c.16.07.31.15.45.23.14.09.26.19.37.31.1.12.18.25.24.41.06.16.09.34.09.54,0,.22-.04.43-.13.62-.09.19-.21.36-.38.51s-.36.26-.59.34-.5.12-.79.12v-.02Z"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M236.77,161.35v-5.58h.71v5.58h-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M240.16,161.35v-4.98h-1.68v-.6h4.08v.6h-1.68v4.98h-.72Z"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M248.77,161.35v-5.58h.71v2.34h2.59v-2.34h.71v5.58h-.71v-2.63h-2.59v2.63h-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M254.32,161.35v-5.58h1.74c.28,0,.54.03.79.08s.45.14.62.27.31.29.4.48c.1.2.14.44.14.73,0,.44-.11.79-.34,1.05s-.53.44-.92.54l1.42,2.43h-.8l-1.34-2.35h-1.01v2.35h-.71,0ZM255.02,158.41h.93c.44,0,.77-.09,1-.27.23-.18.35-.45.35-.81s-.12-.63-.35-.77c-.23-.15-.57-.22-1-.22h-.93v2.07h0Z"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M264.58,161.45c-.39,0-.75-.07-1.09-.22-.33-.15-.62-.35-.87-.6l.43-.49c.2.21.43.38.7.51.27.13.55.19.84.19.37,0,.65-.08.86-.25.2-.17.31-.39.31-.66,0-.14-.02-.26-.07-.36-.05-.1-.11-.18-.2-.26-.08-.07-.18-.13-.29-.19s-.24-.12-.37-.18l-.8-.35c-.13-.06-.26-.12-.4-.2-.14-.08-.26-.18-.37-.29s-.2-.25-.26-.4c-.07-.16-.1-.34-.1-.54s.04-.4.13-.59c.09-.18.21-.34.37-.47s.34-.24.55-.31c.21-.07.45-.11.7-.11.33,0,.64.06.93.19.28.13.52.29.72.5l-.38.46c-.17-.16-.36-.29-.57-.39-.21-.09-.44-.14-.7-.14-.31,0-.56.07-.75.22-.19.14-.29.34-.29.6,0,.14.03.25.08.34s.13.18.22.25.19.13.3.19c.11.05.22.1.33.15l.79.34c.16.07.31.15.45.23.14.09.26.19.37.31.1.12.18.25.24.41s.09.34.09.54c0,.22-.04.43-.13.62s-.21.36-.38.51-.36.26-.59.34-.5.12-.79.12v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M267.57,161.35v-5.58h.71v2.8h.03l2.32-2.8h.8l-1.74,2.12,2.01,3.45h-.79l-1.67-2.9-.96,1.13v1.77h-.71Z"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M276.44,161.35v-5.58h1.66c.28,0,.54.03.78.08s.44.13.6.24c.17.11.3.25.39.42.09.17.14.38.14.62,0,.28-.07.53-.21.75-.14.22-.34.38-.61.46v.03c.34.06.61.2.82.42s.31.52.31.91c0,.27-.05.51-.15.71-.1.2-.25.37-.43.51-.19.14-.41.24-.67.31s-.55.1-.86.1h-1.78v.02ZM277.15,158.14h.82c.48,0,.82-.08,1.03-.25.21-.16.31-.39.31-.67,0-.32-.11-.55-.33-.69s-.54-.2-.98-.2h-.86v1.81h0ZM277.15,160.78h.97c.48,0,.86-.09,1.12-.27.27-.18.4-.46.4-.83,0-.35-.13-.6-.39-.76-.26-.16-.64-.24-1.13-.24h-.97v2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M283.63,161.45c-.37,0-.71-.07-1.02-.2-.31-.13-.57-.32-.79-.57s-.39-.55-.52-.91c-.12-.36-.19-.77-.19-1.22s.06-.85.19-1.21.3-.66.53-.91.5-.44.81-.57.66-.2,1.02-.2c.19,0,.37.02.53.06s.31.09.44.16.25.14.36.22c.1.08.2.17.28.25l-.39.46c-.14-.15-.31-.27-.49-.37-.19-.1-.42-.15-.71-.15s-.54.05-.76.16c-.23.1-.42.26-.58.45-.16.2-.28.43-.37.71-.09.28-.13.59-.13.94s.04.67.12.95.2.52.36.72c.16.2.35.35.58.46.23.11.49.16.79.16.2,0,.39-.03.57-.09s.32-.14.44-.24v-1.45h-1.18v-.59h1.83v2.35c-.18.19-.42.34-.71.46-.29.12-.63.18-1,.18h0Z"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M290.68,161.35v-5.58h.71v4.97h2.44v.6h-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M296.54,161.45c-.28,0-.55-.04-.79-.12-.25-.08-.46-.22-.64-.41s-.32-.44-.42-.74c-.1-.31-.15-.68-.15-1.13v-3.27h.71v3.29c0,.33.03.62.1.84.07.23.16.41.28.54.12.14.25.23.41.29s.33.09.51.09.36-.03.52-.09.3-.16.42-.29c.12-.14.21-.32.28-.54.07-.23.1-.51.1-.84v-3.29h.68v3.27c0,.45-.05.82-.15,1.13s-.24.55-.42.74c-.18.19-.39.33-.63.41s-.51.12-.79.12h-.02Z"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M305.33,161.35v-5.58h.71v4.97h2.44v.6h-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M309.59,161.35v-4.98h-1.68v-.6h4.08v.6h-1.68v4.98h-.72Z"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M317.59,161.35v-5.58h.85l1.07,2.98c.07.19.13.39.2.58.07.2.13.39.2.58h.03c.07-.19.13-.39.19-.58.06-.2.12-.39.19-.58l1.05-2.98h.86v5.58h-.66v-3.07c0-.25.01-.52.03-.82s.04-.58.06-.82h-.03l-.44,1.27-1.05,2.89h-.47l-1.05-2.89-.44-1.27h-.03c.02.25.04.52.06.82s.03.58.03.82v3.07h-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M324.93,161.35v-4.98h-1.68v-.6h4.08v.6h-1.68v4.98h-.72Z"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M332.83,161.35v-5.58h.71v4.97h2.44v.6h-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M337.33,161.35l-1.79-5.58h.76l.89,3.01c.1.33.19.64.27.93.08.28.17.59.28.92h.03c.1-.33.19-.63.27-.92.08-.28.17-.59.26-.93l.89-3.01h.72l-1.77,5.58h-.82,0Z"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M348.24,161.45c-.35,0-.67-.07-.97-.2-.29-.13-.55-.32-.77-.57s-.39-.55-.51-.91-.18-.77-.18-1.22.06-.85.19-1.21c.12-.36.3-.66.52-.91s.48-.44.78-.57.63-.2.99-.2.64.07.9.21.47.3.63.48l-.38.46c-.15-.16-.31-.29-.5-.38-.19-.1-.4-.14-.64-.14-.27,0-.51.05-.72.16-.22.1-.4.26-.55.45-.15.2-.27.43-.35.71-.08.28-.12.59-.12.94s.04.67.12.95.2.52.34.72c.15.2.33.35.54.46.21.11.45.16.72.16s.51-.06.71-.17c.2-.11.4-.27.58-.46l.39.44c-.22.25-.47.45-.75.6s-.6.21-.96.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M351.83,161.35v-2.16l-1.67-3.42h.76l.72,1.57c.09.2.18.41.26.6s.18.4.27.61h.03c.1-.21.19-.41.29-.61s.19-.4.27-.6l.71-1.57h.74l-1.67,3.42v2.16h-.71,0Z"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M359.12,161.35v-5.58h1.74c.28,0,.55.03.79.08.24.05.45.14.62.27s.31.29.4.48c.1.2.14.44.14.73,0,.44-.11.79-.34,1.05s-.53.44-.92.54l1.42,2.43h-.8l-1.34-2.35h-1.01v2.35h-.71,0ZM359.82,158.41h.93c.44,0,.77-.09,1-.27.23-.18.35-.45.35-.81s-.12-.63-.35-.77c-.23-.15-.57-.22-1-.22h-.93v2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M366.01,161.45c-.35,0-.67-.07-.96-.2-.29-.14-.54-.33-.75-.58s-.37-.56-.49-.92-.17-.76-.17-1.21.06-.85.17-1.2.28-.65.49-.9.46-.43.75-.56.61-.2.96-.2.67.07.96.2c.29.13.54.32.76.57.21.25.38.55.49.9.12.35.17.75.17,1.19s-.06.85-.17,1.21-.28.67-.49.92-.46.45-.76.58c-.29.14-.61.2-.96.2h0ZM366.01,160.83c.25,0,.47-.05.68-.16.2-.11.37-.26.52-.46s.26-.44.34-.72.12-.6.12-.95-.04-.66-.12-.94-.19-.51-.34-.71c-.14-.19-.32-.34-.52-.45-.2-.1-.43-.16-.68-.16s-.47.05-.68.16c-.2.1-.37.25-.52.45-.14.19-.26.43-.34.71-.08.28-.12.59-.12.94s.04.67.12.95.19.52.34.72.32.36.52.46c.2.11.43.16.68.16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentInRdByEuMemberStatesGdpDesktop);
export default __webpack_public_path__ + "static/media/investment-in-rd-by-eu-member-states-gdp-desktop.fb7efa68736756527158e8ca5a7751a1.svg";
export { ForwardRef as ReactComponent };